/* eslint-disable max-lines -- generated translation artifact */
import type { TranslationKeyMap } from "../types";

export const I18N_TRANSLATION_KEYS = {
  billingHistory: {
    "(revised)": {
      hash: "359337f0a9c68324",
    },
    "Account statement": {
      hash: "955b9e7a497b0ac3",
    },
    "Billing portal": {
      hash: "6471421a56ffde3c",
    },
    Dispute: {
      hash: "3a8931a9b2f6bf69",
    },
    "Dispute invoice": {
      hash: "37945f0742ea2cc4",
    },
    "Dispute: {{status}}": {
      hash: "5d906349d4fb9e4b",
    },
    Documents: {
      hash: "b4e929d8bcfe0418",
    },
    "Due date": {
      hash: "e1cb6d30fa3f17ee",
    },
    "Due {{dueDate}}": {
      hash: "75b6330de57a7203",
    },
    "Former invoice": {
      hash: "10ffbe511de09f84",
    },
    Invoice: {
      hash: "b832002da297545f",
    },
    "Invoice #{{invoiceNumber}}": {
      hash: "9ecae17e665870ab",
    },
    "Invoice History": {
      hash: "8f74e5015dd26f64",
    },
    "Invoice details": {
      hash: "fc799c7371bffd02",
    },
    "Next year": {
      hash: "a21a5dc62ee1cde3",
    },
    "No invoices": {
      hash: "e6b30f9398c0725b",
    },
    Overdue: {
      hash: "d660945bc2991320",
    },
    Paid: {
      hash: "fb81b961af456e5e",
    },
    Pay: {
      hash: "723afa394daeea97",
    },
    "Pay invoice": {
      hash: "b1dead56e7d7adf2",
    },
    "Previous year": {
      hash: "91e33e3ba5c1ca1a",
    },
    "Revised invoices": {
      hash: "be76c803bf1ebe28",
    },
    Statement: {
      hash: "6171b2a461207d19",
    },
    Status: {
      hash: "920e413c7d411b61",
    },
    Timesheet: {
      hash: "6d320a315fe443f9",
    },
    Total: {
      hash: "c9b3c38247f744e1",
    },
    Unpaid: {
      hash: "4b80e74f3fa47867",
    },
    View: {
      hash: "dcc839a4015c4b7d",
    },
    "View dispute": {
      hash: "79c2657890c42470",
    },
    "View dispute for former invoice": {
      hash: "e5030091dc4e3004",
    },
    "View dispute for invoice #{{invoiceNumber}}": {
      hash: "4a90e7d8d982f4c2",
    },
    "View former invoice": {
      hash: "42e9524eb188efbd",
    },
    "View invoice": {
      hash: "24cb98ea86f38d17",
    },
    "View invoice #{{invoiceNumber}}": {
      hash: "e1dd7ffca8e92b69",
    },
    "View invoice dispute": {
      hash: "5b1a1186e5e400a9",
    },
    "View timesheet": {
      hash: "472c6c914210d3d9",
    },
    "{{invoiceCount}} invoice": {
      hash: "2bc748490ad9ba4e",
    },
    "{{invoiceCount}} invoices": {
      hash: "a328add3ebaecf9b",
    },
  },
  charting: {
    ". They have {{hours}} hour to return to your workplace and ensure your records are audit-ready.":
      {
        hash: "557623c48457054d",
      },
    ". They have {{hours}} hours to return to your workplace and ensure your records are audit-ready.":
      {
        hash: "66d50aca56da2386",
      },
    "All caught up — no recalls in progress": {
      hash: "1298f382394c84cd",
    },
    "All license types": {
      hash: "22b8701f928b506a",
    },
    "All shifts": {
      hash: "95e445f6311803b9",
    },
    Apply: {
      hash: "31e392d1c0378bec",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Charting Compliance Manager": {
      hash: "a472b75dd9eff44b",
    },
    "Charting recall created successfully": {
      hash: "0c3ce3fefa044ee7",
    },
    "Charting report created successfully": {
      hash: "d8d623efaf5a6057",
    },
    "Charting status": {
      hash: "07e1519cd01a1150",
    },
    "Charting verified successfully for {{workerName}}": {
      hash: "0ed27b1c0f670221",
    },
    "Charting was not started": {
      hash: "78d066e77b15d04e",
    },
    "Charting was partially complete": {
      hash: "7fce8c12f5c04833",
    },
    "Create recall": {
      hash: "31bd5db3eee7a15e",
    },
    Done: {
      hash: "11a6767d5674c7e4",
    },
    "Error recalling {{workerName}}: {{message}}": {
      hash: "5e231b20808f1921",
    },
    "Error reporting {{workerName}}: {{message}}": {
      hash: "2f040e8849968259",
    },
    "Error verifying charting for {{workerName}}: {{errorMessage}}": {
      hash: "9255b9f3385cf9ed",
    },
    "Filter charting reports": {
      hash: "973845052fa7ac8b",
    },
    Filters: {
      hash: "546ebb8eb993ea56",
    },
    "Has {{workerName}} returned to complete charting?": {
      hash: "c8ed5004a3a6e5d0",
    },
    "If a professional leaves charting incomplete, you can recall them to complete it": {
      hash: "c286ef143acc2459",
    },
    "In-progress recalls": {
      hash: "7eb8b42fec603757",
    },
    "License type": {
      hash: "72f256afd196ceae",
    },
    "No matching shifts during this time range": {
      hash: "253304095a1bcdd2",
    },
    "Open charting filters": {
      hash: "de0b992e815a9143",
    },
    "Please confirm that {{workerName}} has completed all outstanding documentation for this shift at your workplace. You will not be able to recall them again for this shift.":
      {
        hash: "5a1f27056c4bc26e",
      },
    "Please leave a note for the professional specifying which part of the charting was incomplete.":
      {
        hash: "875c63a7d3bce041",
      },
    Professional: {
      hash: "19c73a5cdf346d96",
    },
    "Provide details on what still needs to be completed (e.g. vitals, meds, progress notes)": {
      hash: "eb1348d4c4294fe6",
    },
    "Recall again": {
      hash: "19e13435115479ea",
    },
    "Recall note": {
      hash: "0eb0d01798771592",
    },
    "Recall note:": {
      hash: "294fa874ea6514e3",
    },
    "Recall to chart": {
      hash: "5bc8cd7dfb5f5ec0",
    },
    "Recall {{workerName}} to complete charting": {
      hash: "cbd247e4246f0cb2",
    },
    "Report as incomplete": {
      hash: "58bb31253b227e14",
    },
    "Report incomplete charting": {
      hash: "fbac2fb49360402d",
    },
    "Reported by": {
      hash: "c170bc77f0f09ba4",
    },
    Reset: {
      hash: "daee7606b339f3c3",
    },
    "Search for a professional": {
      hash: "2e71da3a95d291bc",
    },
    "Selected range": {
      hash: "d34fef882db4af9b",
    },
    Shift: {
      hash: "2e544a292f6979ed",
    },
    "Shift date": {
      hash: "3e0c029234155245",
    },
    "Shift date range": {
      hash: "8a8fd5cf53233987",
    },
    "Submit report": {
      hash: "b41fd589ad91ed78",
    },
    Undo: {
      hash: "a8283ade31856f71",
    },
    Verify: {
      hash: "eea2745e2867a677",
    },
    "Yes, mark charting as complete": {
      hash: "88b4e196562e9d6c",
    },
    "free of charge": {
      hash: "f91e0c5b9e2b5ec3",
    },
  },
  chat: {
    "AM Shift": {
      hash: "a7cf9363556dd4ca",
    },
    Accept: {
      hash: "89713b9c9c1b8f65",
    },
    "Add to starred": {
      hash: "846d05b5aec949db",
    },
    All: {
      hash: "a52ace420f2175d0",
    },
    "Application Received": {
      hash: "4022255740ab5a30",
    },
    "Approve this shift as a sent home?": {
      hash: "8dc90f8c6f07b3a3",
    },
    "Are you sure you want to unlock this professional?": {
      hash: "4758b5bc7d94c1bb",
    },
    "Attach file": {
      hash: "87fbe4fb79b1d700",
    },
    Back: {
      hash: "76900f1bfd16c8d4",
    },
    "Back to conversations": {
      hash: "d456fc75664472cc",
    },
    "Book Interview": {
      hash: "e7eab2eac45a75af",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Cancel edit": {
      hash: "6fa271453f8ac490",
    },
    "Cancel reply": {
      hash: "2355f73150190fc7",
    },
    "Cannot accept new Home Health visits": {
      hash: "7d99b198ba5bad55",
    },
    "Cannot be assigned to new cases": {
      hash: "173874fc674b3464",
    },
    "Channel filters": {
      hash: "1aa4263bbe43cfdd",
    },
    "Chat Unavailable": {
      hash: "fd9b5c64be299307",
    },
    "Chat message": {
      hash: "f6820511a8178983",
    },
    "Chat messages": {
      hash: "4165e2978c2117ef",
    },
    "Close chat": {
      hash: "3b14c5dc986f2a36",
    },
    "Close dialog": {
      hash: "c8df66c5fe3f97d0",
    },
    "Close image preview": {
      hash: "1b9e1aa135771a2f",
    },
    "Confirm No Show": {
      hash: "a7826132abbfe036",
    },
    Continue: {
      hash: "31fbef162594de01",
    },
    Date: {
      hash: "99c40ab405926cb5",
    },
    Decline: {
      hash: "a2d285b352873457",
    },
    Delete: {
      hash: "e2d0a54968ead24e",
    },
    "Delete message?": {
      hash: "0464d777d1568a1c",
    },
    "Describe what needs to happen before this professional can be unlocked...": {
      hash: "538b6cc4892537c8",
    },
    "Describe why this professional's account should be locked...": {
      hash: "37281adc1ef51df7",
    },
    "Did {{workerName}} leave the shift early?": {
      hash: "4e832591dc95eda7",
    },
    "Do you accept this sent home request?": {
      hash: "90821a3431c5603c",
    },
    "Don't send": {
      hash: "11feeff6baecd5a9",
    },
    "Download file": {
      hash: "9de4149fb9716cfc",
    },
    Edit: {
      hash: "464c4ffd019e1e96",
    },
    "Editing message": {
      hash: "7dbfd44a87232deb",
    },
    "Expiring in {{displayDuration}}": {
      hash: "94518be867eb2f8a",
    },
    "Failed to approve request": {
      hash: "c97583fe90258cd7",
    },
    "Failed to cancel message": {
      hash: "d9924a3cf77aeffe",
    },
    "Failed to create chat channel": {
      hash: "c71cf96ff4711ee0",
    },
    "Failed to delete message": {
      hash: "5ce4aeba4357203a",
    },
    "Failed to edit message": {
      hash: "da8e926af6449411",
    },
    "Failed to load chat messages. Please try again.": {
      hash: "ce071bf9950dfa05",
    },
    "Failed to load conversations": {
      hash: "ae55fc046c4cf3ae",
    },
    "Failed to lock this professional. Please try again.": {
      hash: "5268ce545cfd1bc5",
    },
    "Failed to mark chat as unread": {
      hash: "b780d4652d4724a2",
    },
    "Failed to reject request": {
      hash: "ba4a26dec0142695",
    },
    "Failed to report No Show. Please try again.": {
      hash: "5d8f22798b0e32ef",
    },
    "Failed to report Worker Left Early. Please try again.": {
      hash: "7344c04e9e307c21",
    },
    "Failed to send message": {
      hash: "66b8e077d85fe969",
    },
    "Failed to unlock this professional. Please try again.": {
      hash: "895e24c74a7ddb71",
    },
    "Failed to upload file": {
      hash: "93c948f6c294adc0",
    },
    "File size must be less than 10MB": {
      hash: "7fd435c1a03f8f28",
    },
    Flex: {
      hash: "c2a520b84ceea67c",
    },
    Hiring: {
      hash: "4e414af41b7d4876",
    },
    "How to Unlock": {
      hash: "73cb145a22b3d8e6",
    },
    "Interview Cancelled": {
      hash: "fcb2f91b76efc2d6",
    },
    "Interview Invite": {
      hash: "8b4a28105b186b0e",
    },
    "Interview Suggested": {
      hash: "9faca3224d9578d1",
    },
    "Interview invite cancelled": {
      hash: "653ecb88c925d69a",
    },
    "Interview invite sent": {
      hash: "7286a96c2bd8186e",
    },
    "Interview scheduled": {
      hash: "3ed9b6a64daba284",
    },
    "Interview scheduled successfully": {
      hash: "b0f496c73d51b975",
    },
    "Invite as": {
      hash: "eb109d5d22dd2477",
    },
    "Invite to Shift": {
      hash: "7dc2c9b04fedc9a4",
    },
    "Invite to shift": {
      hash: "6a63d328d7b3d4e8",
    },
    "Job listing: {{placementTitle}}": {
      hash: "1c7af185ab9ab67c",
    },
    "Load more messages": {
      hash: "bc1c7de0ef33b464",
    },
    "Loading shift times...": {
      hash: "3f3bbdf89cbfb1fe",
    },
    Lock: {
      hash: "db44b8db4f05d720",
    },
    "Lock Professional": {
      hash: "37a407f7f7ca1e14",
    },
    "Lock Professional's Account": {
      hash: "25a54122b93c5f88",
    },
    Locked: {
      hash: "a424e33d90931d1e",
    },
    "Locking this professional will:": {
      hash: "bd8f7395f7c52d38",
    },
    "Manage jobs": {
      hash: "eb13fd621c1e72ae",
    },
    "Mark as unread": {
      hash: "2c19d584bf8ad518",
    },
    "Mark conversation as unread": {
      hash: "c821e8b037f955b7",
    },
    "Message cancelled": {
      hash: "516efaba309fba5d",
    },
    "Message options": {
      hash: "5e31e8926ceba729",
    },
    "Message sent": {
      hash: "0a1f2fbcba7a4924",
    },
    "More chat options": {
      hash: "14d3e2bd48ff4eb2",
    },
    "NOC Shift": {
      hash: "f8d5b1186d791b61",
    },
    "New message": {
      hash: "78f5975a5d705e95",
    },
    "No conversations match your filters": {
      hash: "9c4ff530a4b48196",
    },
    "No conversations yet": {
      hash: "0d60084f056eb4cf",
    },
    "No messages": {
      hash: "a06faf2668c28d0b",
    },
    "No messages yet. Start a conversation with {{workerName}}!": {
      hash: "b269519c244f2c88",
    },
    "No, don't approve": {
      hash: "6c3fe8584f8cba3d",
    },
    "No, worker was not sent home": {
      hash: "a1911a805b2e584a",
    },
    Notes: {
      hash: "8a7525b1492fb848",
    },
    "Only workplace users can send messages": {
      hash: "554e7df8055a5b26",
    },
    "PM Shift": {
      hash: "93b9bd5f34693a9f",
    },
    "Please add notes to describe why the worker was not sent home.": {
      hash: "905215e97d44789f",
    },
    "Please fill out reason for approval.": {
      hash: "436f860b57898463",
    },
    "Please fill out reason for rejection.": {
      hash: "9f411825daab7e3e",
    },
    "Please note this reason will be shared with the worker.": {
      hash: "e82ce23a48d44e4a",
    },
    "Please provide context for your approval reason": {
      hash: "5203691edc6eac2a",
    },
    "Please select if you'd like us to post an urgent replacement shift.": {
      hash: "87f6dfda0977757d",
    },
    "Please use judgment and professionalism.": {
      hash: "2b3f7fdef47be7d9",
    },
    "Prevent them from accepting new visits": {
      hash: "93063f0beabb3a5d",
    },
    "Prevent them from being assigned to new cases": {
      hash: "9e91a3e9c73c3a08",
    },
    Professional: {
      hash: "19c73a5cdf346d96",
    },
    "Professional's account locked": {
      hash: "7ad7363a5819c924",
    },
    Read: {
      hash: "9b9a8d05a7ec353b",
    },
    "Reason for Locking": {
      hash: "6f0943b503a938bb",
    },
    "Reason for approval": {
      hash: "9a54e5b2b4151dfa",
    },
    "Reason for rejection": {
      hash: "6f4cd7c8dcf57167",
    },
    Reasons: {
      hash: "72ed245d2cf11822",
    },
    Remove: {
      hash: "c3812fc4acb861d5",
    },
    "Remove from starred": {
      hash: "f1133f6566cd1093",
    },
    "Reply to message": {
      hash: "11dab6274664c362",
    },
    "Replying to {{senderName}}": {
      hash: "66aff25b2a4034ab",
    },
    "Report Worker Left Early": {
      hash: "ed4d44fa08fd38d0",
    },
    Retry: {
      hash: "942087cc2d41e013",
    },
    "Review the sent home request": {
      hash: "419d2b38764f8681",
    },
    "Scheduled interview invite": {
      hash: "efffe1f9cd058fbe",
    },
    "Scheduled interview invite pending": {
      hash: "6103ae51803696cf",
    },
    "Search...": {
      hash: "7f55382219f0202c",
    },
    "Select a conversation": {
      hash: "12d82ae5928141ae",
    },
    "Send message": {
      hash: "93a26b1eaff99b3a",
    },
    "Send now": {
      hash: "588032878324b5e6",
    },
    Sent: {
      hash: "c16bc82bf1f04ede",
    },
    "Share credentials": {
      hash: "257c8051763d5f71",
    },
    Shift: {
      hash: "2e544a292f6979ed",
    },
    Starred: {
      hash: "07a2d579c3f0d325",
    },
    "Starred professional": {
      hash: "44b23f3add41fbac",
    },
    Submit: {
      hash: "155f816c0407310c",
    },
    "Thanks for your response!": {
      hash: "6973cb606bc78799",
    },
    "The lock will expire automatically after {{days}} days.": {
      hash: "6a94bfa8b699d2e5",
    },
    "These responses will be shared with the professional in the chat.": {
      hash: "14e05c7949dda7ca",
    },
    "This is an automated message sent on behalf of your facility": {
      hash: "8b2bd68e24610c8d",
    },
    "This message will be permanently removed for everyone.": {
      hash: "2396999ffc3ba483",
    },
    "This professional cannot be invited to shifts at this workplace.": {
      hash: "15db6cf63b74d63f",
    },
    "This professional's account has been locked by another workplace. While locked, this professional:":
      {
        hash: "bb1b36b33a11ea0f",
      },
    "This will last for {{days}} days. Enter lock details on the next page.": {
      hash: "65e3db405524457a",
    },
    "Type your message...": {
      hash: "e9bddf7360b6dc62",
    },
    Unlock: {
      hash: "4ac709aa58bcfe5d",
    },
    "Unlock Professional": {
      hash: "274888e3d8ba0795",
    },
    Unread: {
      hash: "1b9f384c1436f607",
    },
    "Unsupported file type. Please upload images, PDFs, or Word documents.": {
      hash: "17a9724ab58b6c42",
    },
    "View calendar": {
      hash: "206eea992f2daf12",
    },
    "View candidate": {
      hash: "314c0fae93ae57c3",
    },
    "View details": {
      hash: "d1bf045bb524dae5",
    },
    "View profile": {
      hash: "d4788f256f730423",
    },
    "Was {{workerName}} a No Show?": {
      hash: "0ec2ae49e4414937",
    },
    Worker: {
      hash: "a67b04cd5c491d4d",
    },
    "Worker asked me to cancel": {
      hash: "dc1011d87ddbaa17",
    },
    "Yes, approve": {
      hash: "a5e4ce04a6cd1577",
    },
    "Yes, worker was sent home.": {
      hash: "61006b850c2d1765",
    },
    "Yes, {{workerName}} never showed up to work the shift": {
      hash: "4938e979a0d0a156",
    },
    "Yes, {{workerName}} never worked the complete shift": {
      hash: "df576ba623e98119",
    },
    "You may provide context for your approval reason": {
      hash: "7ea56b231dd1fba8",
    },
    "You proposed a new shift time": {
      hash: "2487e3d832ca50b9",
    },
    "You sent a shift invite": {
      hash: "f66617b0bd919384",
    },
    "You sent multiple shift invites": {
      hash: "97cce8bbb9df463f",
    },
    "Your message was cancelled successfully.": {
      hash: "9301b7e607985030",
    },
    "Your message was sent successfully.": {
      hash: "98dad1bca40bbcf9",
    },
    "{{currentLength}}/{{minimumLength}} minimum characters": {
      hash: "8ec1b7b0dfed097f",
    },
    "{{workerName}} is currently blocked from this workplace.": {
      hash: "b0c1b5c59c40d7e4",
    },
    "· edited": {
      hash: "0d79ff168b4abad5",
    },
  },
  common: {
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Clear search": {
      hash: "3b7ea51793e9d906",
    },
    "Close dialog": {
      hash: "c8df66c5fe3f97d0",
    },
    "Close drawer": {
      hash: "7a0d06d516580b7f",
    },
    "Collapse timeline": {
      hash: "5fbc1e7e7e83b837",
    },
    "Copied!": {
      hash: "ea61bc15688d1e48",
    },
    "Decrease quantity": {
      hash: "6c15c542ce67f0a9",
    },
    "Dismiss coachmark": {
      hash: "999d5198e33dfdb4",
    },
    Download: {
      hash: "d6eafe8235910042",
    },
    "Download for Android": {
      hash: "08f13c0eaa454ceb",
    },
    "Download for iOS": {
      hash: "7707b94233940ee1",
    },
    "Download the Clipboard Workplace app to view your schedule, post shifts, and message your workers on the go.":
      {
        hash: "2074af6eeb2b3275",
      },
    "Edit Limit": {
      hash: "916d8ebfe068b43a",
    },
    "Edit time": {
      hash: "59ebe97eedd6795e",
    },
    "Error Loading Notifications. Please try again later.": {
      hash: "926cc946fedafbf5",
    },
    "Error loading document": {
      hash: "1cd58655ba2331c9",
    },
    "Expand timeline": {
      hash: "0d0e02e4ceed56d5",
    },
    "Increase quantity": {
      hash: "6248346eae8d0df7",
    },
    "Local time: {{localTime}}": {
      hash: "43d6f08e4edb5431",
    },
    Menu: {
      hash: "99af6606ff9d6cd5",
    },
    "Next day": {
      hash: "2b6a38b89f9c7b30",
    },
    "No current notifications": {
      hash: "51ade6c018ded413",
    },
    "No weekly limit": {
      hash: "eb0c3ed107b24c4b",
    },
    "Not recorded": {
      hash: "b37c7879f6c359f6",
    },
    Notifications: {
      hash: "788011833a5a0f22",
    },
    "Previous day": {
      hash: "e4a1e89ee1db53ce",
    },
    Print: {
      hash: "df0fe79898ef413e",
    },
    "Request Increase": {
      hash: "efe7287d10ef5fe2",
    },
    "Request Sent": {
      hash: "0cf3a3f729944fa0",
    },
    "Set Limit": {
      hash: "71139c3ae28e7d90",
    },
    "Take Clipboard with you": {
      hash: "efd29d8c54d0a8ff",
    },
    "This week has already ended": {
      hash: "7587b4b51fb544fa",
    },
    "Weekly limit": {
      hash: "93483c938871b25a",
    },
    am: {
      hash: "ab6db599234d2636",
    },
    pm: {
      hash: "96f2f0811df88d8f",
    },
    "{{currentStep}} of {{totalSteps}}": {
      hash: "685e43d81887725c",
    },
  },
  dnr: {
    "Add DNR": {
      hash: "4aadd98175f7d02c",
    },
    "Added {{createdDate}}": {
      hash: "9acd5ca87a2df72c",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Copy all DNRs from a source workplace to a target workplace. Workers already DNR'd at the target workplace will be skipped.":
      {
        hash: "3eea447b9a0f6500",
      },
    "DNR List": {
      hash: "24fea1562512ef18",
    },
    "DNR record deleted": {
      hash: "d515313ac37e7359",
    },
    "Date Created": {
      hash: "ffb2623aad3197de",
    },
    Delete: {
      hash: "e2d0a54968ead24e",
    },
    "Delete DNR": {
      hash: "c7ee9ee512665837",
    },
    "Delete DNR record": {
      hash: "c9eea6fa483c8dec",
    },
    "Delete this DNR record?": {
      hash: "b3122b441bb9c72b",
    },
    "Enter additional notes...": {
      hash: "de98a1aeef07296d",
    },
    "Enter reason for deletion...": {
      hash: "95a1a159ad1b6bb7",
    },
    "Failed to delete DNR record": {
      hash: "9f90b6a53e10a134",
    },
    "Failed to load DNR data. Please try again.": {
      hash: "9688369e4a3c1d45",
    },
    "ID: {{id}}": {
      hash: "e87ced5e089eba2b",
    },
    "No DNR records found for this worker": {
      hash: "f30d0fbd79351450",
    },
    Notes: {
      hash: "8a7525b1492fb848",
    },
    "Notes:": {
      hash: "da4f7ea58d963b1a",
    },
    Reason: {
      hash: "f81ab834de5f8491",
    },
    "Reason for deletion": {
      hash: "01d8efda72cd3d07",
    },
    Reasons: {
      hash: "72ed245d2cf11822",
    },
    "Reasons:": {
      hash: "39086c62b8953f38",
    },
    "Recorded By": {
      hash: "b75b00f46e72dc5e",
    },
    "Search source workplace": {
      hash: "1f788a0ac35935a7",
    },
    "Search target workplace": {
      hash: "4b8e893689d8dc65",
    },
    "Searching workplaces...": {
      hash: "cc2111dd92b635db",
    },
    "Select a workplace to add to the DNR list for this worker.": {
      hash: "6feb9cfbce4c4fb9",
    },
    "Select all that apply": {
      hash: "10d20e340181a52f",
    },
    "Sort by {{columnLabel}}, currently {{sortState}}": {
      hash: "ebe8d8f42b26353a",
    },
    "Source and target workplaces must be different.": {
      hash: "29e53f7f6b5bff7d",
    },
    "Source workplace": {
      hash: "12d9815fef885712",
    },
    "Start typing workplace name...": {
      hash: "6031ee797185af1e",
    },
    Submit: {
      hash: "155f816c0407310c",
    },
    "Target workplace": {
      hash: "322d9f6cd4c0ce6a",
    },
    "The source workplace has no DNRs to copy.": {
      hash: "0896420838398301",
    },
    "This entry will be permanently removed and the worker can be matched with this workplace again.":
      {
        hash: "de5541d57b4ee198",
      },
    "Transfer DNRs between workplaces": {
      hash: "0031ddd1d1262240",
    },
    Unblock: {
      hash: "712da63171e0c9de",
    },
    "Unknown workplace": {
      hash: "38c1d970ac4a549b",
    },
    Workplace: {
      hash: "09fd2948a8dffd21",
    },
  },
  evidence: {
    Actions: {
      hash: "ff8059dc6752afdd",
    },
    "An unexpected error occurred. Please try again.": {
      hash: "e198269c2a19003d",
    },
    Approved: {
      hash: "87b42e40c2a290e0",
    },
    "Created At": {
      hash: "3d44337010bfbdf7",
    },
    "Definition Name": {
      hash: "2f491f07735e7056",
    },
    "Document ID": {
      hash: "2f2a95ec93b25e34",
    },
    "Edit Evidence": {
      hash: "b89ab3b119b92f94",
    },
    Evidence: {
      hash: "03867aea70acaf4c",
    },
    "Evidence Definition": {
      hash: "1a83135d903dcd9e",
    },
    "Evidence ID": {
      hash: "d1957085c29dbd37",
    },
    "Evidence created successfully": {
      hash: "bc601ec106f42318",
    },
    "Evidence definition not found. Evidence properties cannot be edited.": {
      hash: "2cd3f75e8d4737b4",
    },
    "Evidence updated successfully": {
      hash: "271d48fc7d5d9dd4",
    },
    Evidences: {
      hash: "6ee7448a9c057091",
    },
    "Existing Documents": {
      hash: "799ccd9dee898c80",
    },
    "Expiry Date": {
      hash: "d600e62a6861fced",
    },
    "Failed to load document preview.": {
      hash: "0b1548eb25a9799d",
    },
    "Failed to load documents. Please try again.": {
      hash: "5265434bb9e0e789",
    },
    "Failed to load evidence definitions. Evidence properties cannot be edited.": {
      hash: "29c37ce298a5399a",
    },
    "Failed to load evidence definitions. Please try again.": {
      hash: "fea31386a31f34c6",
    },
    "Failed to load evidences. Evidence linking may be incomplete.": {
      hash: "b4aaa11cf013f6d7",
    },
    "Failed to load evidences. Please try again.": {
      hash: "6fed375409557a57",
    },
    "Filter by definition name or evidence ID": {
      hash: "a5cc6e9c339ea39b",
    },
    "Filter by name or document ID": {
      hash: "01a48705b40e69f7",
    },
    "Filter by status": {
      hash: "94d5a7703a8250de",
    },
    "In Review": {
      hash: "2677214a9268a547",
    },
    "Loading document preview...": {
      hash: "19fbc2613e4a1d81",
    },
    Name: {
      hash: "dcd1d5223f73b3a9",
    },
    No: {
      hash: "1ea442a134b2a184",
    },
    "No documents found for this worker.": {
      hash: "76f14c379dff48a2",
    },
    "No documents match the filter.": {
      hash: "6cbf9de5aca6b84c",
    },
    "No evidences found for this worker.": {
      hash: "e6db68ccd8cfaca3",
    },
    "No evidences match the filter.": {
      hash: "9569cdd073575b1d",
    },
    Pending: {
      hash: "331551b0de4157c9",
    },
    "Please enter a valid Worker ID to view documents and evidences.": {
      hash: "4976197fe3f2bdd4",
    },
    Rejected: {
      hash: "aea4a04a80426ed8",
    },
    "Select a definition": {
      hash: "2aa9e2ac7a12cb55",
    },
    "Select an evidence definition to continue.": {
      hash: "d8500d3836a2086e",
    },
    "Select {{fieldKey}}": {
      hash: "6f5708dda91a3dd7",
    },
    Status: {
      hash: "920e413c7d411b61",
    },
    "This definition has no properties to fill in.": {
      hash: "e87247d44d94398d",
    },
    "Unknown definition": {
      hash: "0cd55c8e8865f98b",
    },
    "Updated At": {
      hash: "e35c8e4f5cb5c554",
    },
    "View document": {
      hash: "b5b8cb11a02602cf",
    },
    "View evidence": {
      hash: "2ed9337dcc8cf799",
    },
    "Worker Evidences": {
      hash: "8c13bf02a1a2b30e",
    },
    "Worker ID": {
      hash: "069d7e9d898e4d81",
    },
    "Worker evidence sections": {
      hash: "3d03011c07c575f8",
    },
    Yes: {
      hash: "85a39ab345d672ff",
    },
  },
  facilityUser: {
    Email: {
      hash: "969ccbd3cf6300ec",
    },
    "Failed to update notification preferences": {
      hash: "9e956229d85c31df",
    },
    "Home health notification preferences": {
      hash: "d2f8538027aed163",
    },
    Notification: {
      hash: "7d31b83313991d4c",
    },
    Off: {
      hash: "ca7981b46ecf2c17",
    },
  },
  gettingStarted: {
    Android: {
      hash: "6d612a86bee4b0a6",
    },
    "Download the Clipboard Workplace Mobile App": {
      hash: "15852ba9fdafaa1c",
    },
    "Failed to update. Please try again.": {
      hash: "358a97b9bb66c070",
    },
    "Fill your shifts with trusted professionals": {
      hash: "ac70249101626e2d",
    },
    "Get Started": {
      hash: "983f311018642b0a",
    },
    "Here's how to get started...": {
      hash: "aa26583ec8dbfb73",
    },
    IntermediateShiftPostingModal: {
      hash: "ad1e8b5af91b0b2e",
    },
    "Invite Professionals You Know to Join Clipboard with You!": {
      hash: "6a9e16f0fb0cd7ae",
    },
    "Invite Staff": {
      hash: "5256900289c82266",
    },
    "Invite staff": {
      hash: "981038b9aea98b69",
    },
    "Manage your schedule, post shifts, and message workers on the go.": {
      hash: "eeeef2e208677554",
    },
    "Post more shifts": {
      hash: "b7b7cd05c471d63b",
    },
    "Post shifts": {
      hash: "d3159e27a9330927",
    },
    "Post your first shift": {
      hash: "9ceda19cf812ec8a",
    },
    "Post your staffing needs": {
      hash: "6a58cf22edab0bf9",
    },
    "See what else you can do": {
      hash: "5cff875ddac5c777",
    },
    Skip: {
      hash: "28d03596d24eeb4e",
    },
    "Take Clipboard with you": {
      hash: "efd29d8c54d0a8ff",
    },
    "What types of shifts do you want to post first?": {
      hash: "3d56ae33bf72d534",
    },
    "You can invite staff to join Clipboard anytime!": {
      hash: "e789a9857da6e2b1",
    },
    "You posted your first staffing request!": {
      hash: "8640d6e1e13d439c",
    },
    iOS: {
      hash: "355f5e74848522db",
    },
    "offer a block of shifts": {
      hash: "7be9efc23bd18b68",
    },
  },
  helpCenter: {
    "Account Manager": {
      hash: "ccc498b77ae62cf8",
    },
    "Billing Rep": {
      hash: "a60530deb3fa0a97",
    },
    "Browse all articles": {
      hash: "cb51da6d9dfab99d",
    },
    "Call 24/7 support": {
      hash: "7b1c58a64d814c47",
    },
    "Call support": {
      hash: "d86f74b180c59e24",
    },
    "Can't find what you're looking for?": {
      hash: "0a426a7cf7035aba",
    },
    "Choose a topic below to find answers and instructions.": {
      hash: "8f0e6ece108b7b9c",
    },
    "Dedicated contacts": {
      hash: "2dd25cabbad6c9c2",
    },
    "Download our mobile app to manage your schedule, post shifts, and message your workers on the go.":
      {
        hash: "4f6bbf0f453c2c4f",
      },
    "Error loading support articles.": {
      hash: "a0ccee4b426b3aa7",
    },
    "Get answers about managing shifts, coordinating workers, and troubleshooting your account.": {
      hash: "d9db9c736ed99c3f",
    },
    "Help Center": {
      hash: "a78cebc44214256b",
    },
    "Help by topic": {
      hash: "0cf8e2a03758919e",
    },
    "How can we help?": {
      hash: "7b56e0d0b308abe4",
    },
    "No support articles are available right now.": {
      hash: "e28362912cdcde21",
    },
    "No support articles match your current search.": {
      hash: "a7156767610022e1",
    },
    "Open the full support library.": {
      hash: "2217586c67cc8dd5",
    },
    "Reach support directly and we'll help you right away.": {
      hash: "21e344a9d52f4984",
    },
    "Scan to download": {
      hash: "d968ef24f7787160",
    },
    "Search for articles...": {
      hash: "617630ea4d370ebc",
    },
    "Send details and we'll follow up.": {
      hash: "fc1c61ecc2038c73",
    },
    "Submit a request": {
      hash: "6b491c7346cc1fdd",
    },
    "Submit request": {
      hash: "917e144e4bc3da89",
    },
    "Take Clipboard with you": {
      hash: "efd29d8c54d0a8ff",
    },
    "Talk to support any time.": {
      hash: "88caafee4e66991a",
    },
    "Your dedicated Clipboard Health team members.": {
      hash: "dd1ffc861bb9cd27",
    },
  },
  homeHealth: {
    "Cap value:": {
      hash: "c2de3de5b2a9333c",
    },
    "Clear pin": {
      hash: "cb6fb1213746e5f5",
    },
    "Clear search": {
      hash: "3b7ea51793e9d906",
    },
    "Click anywhere on the map to request coverage in that area.": {
      hash: "ab4fd936bc6d3cd0",
    },
    "Clinician type": {
      hash: "293e087f99c84115",
    },
    "Coverage Map": {
      hash: "ac9cde5b5bee03f3",
    },
    "Failed to load coverage map. Please try again.": {
      hash: "f56bc1e7bc084f94",
    },
    "Failed to load visits. Please try again.": {
      hash: "3d756ca324ccae30",
    },
    "Got it": {
      hash: "5ad3dbd1242a4cea",
    },
    "Heatmap intensity cap": {
      hash: "e92eea890c7f4b8b",
    },
    "Heatmap intensity scaling (admin)": {
      hash: "2dc1717c0074bd4c",
    },
    "Highlighted area shows previously fulfilled visits across Clipboard": {
      hash: "4dee407fa380008c",
    },
    "How the Coverage Map works": {
      hash: "b9d487da5990f1de",
    },
    "Loading coverage…": {
      hash: "c019fb04d862089c",
    },
    "Loading…": {
      hash: "ba3bbbe10d8bef66",
    },
    "Locating…": {
      hash: "ac56027a0ba70a7c",
    },
    "Log scale": {
      hash: "50d4275468f0c0d1",
    },
    "Max intensity cap": {
      hash: "3b629d1d6fd1ce07",
    },
    "Need coverage in this area?": {
      hash: "6e7103f8c2ed7887",
    },
    "No completed visits in this area yet. Click anywhere on the map to request coverage here.": {
      hash: "fbdd2c9ace74f84d",
    },
    "No visits to verify.": {
      hash: "004a86e27232fce7",
    },
    "None (auto-normalize)": {
      hash: "9bebab3f16041c90",
    },
    "Notes (optional)": {
      hash: "6239b93e96e9a8ee",
    },
    "Number of visits": {
      hash: "276683a048d4c29a",
    },
    "Pin set": {
      hash: "78dd445a55afa050",
    },
    "Pin: {{pinLabel}}": {
      hash: "7a8708adfd9c68b3",
    },
    "Reading the map": {
      hash: "14f1ef21204a85f6",
    },
    "Request Future Coverage": {
      hash: "70b988869f2c2a82",
    },
    "Request received": {
      hash: "4f2273f736249aba",
    },
    "Search a city or address": {
      hash: "f509fc0b514d654c",
    },
    "Submit request": {
      hash: "917e144e4bc3da89",
    },
    "The Coverage Map isn't enabled for your account yet.": {
      hash: "a565fb28723f9f18",
    },
    "Visit Verification": {
      hash: "c897635c22a67087",
    },
    "Visit type": {
      hash: "18975c6a5e5e2e65",
    },
    "We'll be in touch if we can find coverage there.": {
      hash: "3074159c5075a11a",
    },
    "Welcome to the Coverage Map": {
      hash: "0493cb969d91ea9a",
    },
    "What the pay rates mean": {
      hash: "7837f28c5c87bc30",
    },
    "Whose data is this?": {
      hash: "eb36aff7bf025843",
    },
    "Your request signals demand so we can plan future hiring in this area. It hasn't created a case or triggered an urgent fulfillment workflow.":
      {
        hash: "cceafec6b909cdc4",
      },
    "e.g., We are getting patients who need wound care": {
      hash: "aba684644f28ed36",
    },
    "in view": {
      hash: "21a7351e10e648b7",
    },
    visit: {
      hash: "f0e68ac26df21840",
    },
    visits: {
      hash: "b944075326e4926e",
    },
  },
  lastMinuteOptInVariableCharge: {
    "Add a bonus to broadcast the shift to all nearby professionals via text": {
      hash: "0fefec6a07c4b967",
    },
    "It's last minute!": {
      hash: "e9a6f4e81f435845",
    },
    "No thanks, create shift at the original rate": {
      hash: "e8df58f48182750b",
    },
    "Set your own…": {
      hash: "f9e9c29177cb6726",
    },
  },
  liveWorkerEta: {
    Actions: {
      hash: "ff8059dc6752afdd",
    },
    "Arrived at {{arrivedTime}}": {
      hash: "c71c7bd6882ad7c9",
    },
    Chat: {
      hash: "460b3a7da007b7af",
    },
    "ETA: {{etaTime}}": {
      hash: "2d8cbda0cc14afb6",
    },
    "Estimated Time of Arrival": {
      hash: "42b42fa1ddc8ef9a",
    },
    "Hide on Map": {
      hash: "63eb561dbf27be58",
    },
    "Live Worker ETA": {
      hash: "4e952b41752d7990",
    },
    "No Information": {
      hash: "247a45c3415e9336",
    },
    "No upcoming shifts": {
      hash: "6fc3b01a3743e0bb",
    },
    "Our estimate: {{etaTime}} arrival": {
      hash: "383b084da568040f",
    },
    Professional: {
      hash: "19c73a5cdf346d96",
    },
    "Shift Information": {
      hash: "16d2a82fd6e5b96f",
    },
    "Shift Start: {{shiftStartTime}}": {
      hash: "175a2747a35d5e64",
    },
    "Show all on Map": {
      hash: "9e86fb3406204da6",
    },
    "Show on Map": {
      hash: "7371031c223e1545",
    },
    "Type: {{shiftQualification}}": {
      hash: "3fba2c78314f1915",
    },
    "Updated {{updatedAt}}": {
      hash: "82eab215405dc397",
    },
    "Worker reported: {{workerDeclaredEta}} arrival": {
      hash: "e97aa9177af0106d",
    },
    "{{etaTime}} arrival": {
      hash: "6e032f5357f0e998",
    },
    "{{workerName}} has not left for their shift yet": {
      hash: "9b64e6f7d70b02b0",
    },
  },
  login: {
    "Back to sign in": {
      hash: "71fe31ccd37c3268",
    },
    "Contact Us": {
      hash: "98b67063cf8e584d",
    },
    "Don't have a workplace account?": {
      hash: "eaf8ba323e085de5",
    },
    "Download our mobile app to view your schedule, post shifts, and manage your workers on the go.":
      {
        hash: "f9e99faee0617e78",
      },
    Email: {
      hash: "969ccbd3cf6300ec",
    },
    "Enter your email address and we'll send you a link to reset your password.": {
      hash: "37b6a0fef1e97e04",
    },
    "Enter your email to get started": {
      hash: "c2e34604b7790d68",
    },
    "Forgot your password?": {
      hash: "afd25fdf17c7f534",
    },
    "Get Sign-in Link": {
      hash: "0637d8a0a26252f2",
    },
    Password: {
      hash: "e7cf3ef4f17c3999",
    },
    "Please enter your email address first.": {
      hash: "928443dc9d5b845c",
    },
    "Please enter your email id again to verify login link": {
      hash: "c473cfc3f1f6e46f",
    },
    "Reset link sent": {
      hash: "aead8ab55bd0b8e6",
    },
    "Reset your password": {
      hash: "59fa4379be1f3398",
    },
    "Scan to download": {
      hash: "d968ef24f7787160",
    },
    "Send Reset Link": {
      hash: "7d5f16d496d4e50d",
    },
    "Send another email": {
      hash: "72b478e8cf489a6d",
    },
    "Sign In": {
      hash: "bcc0bcc9140b0c97",
    },
    "Sign in with SSO": {
      hash: "73e984e9b4809573",
    },
    "Sign in with email & password": {
      hash: "50000feaf7e92d26",
    },
    "Sign in with email and password": {
      hash: "fe40fa3034212960",
    },
    "Sign in with link": {
      hash: "79a5190510175d40",
    },
    "Sign up": {
      hash: "5e2b8e96503d722e",
    },
    "Something went wrong. Please try again.": {
      hash: "3ccd9d6586ef9143",
    },
    "Take Clipboard with you": {
      hash: "efd29d8c54d0a8ff",
    },
    "Unable to start SSO sign-in. Please try again.": {
      hash: "4bdfea0578b5a2ab",
    },
    "Verification link sent": {
      hash: "0a36f5f5f26c781a",
    },
    "Verify Email": {
      hash: "9ae9fbbcb1c80ca9",
    },
    "We have sent a password reset link to {{email}}. Check your email and follow the instructions.":
      {
        hash: "609e2a776c1cdc73",
      },
    "We have sent an email with a login link to {{email}}.": {
      hash: "2dd2d99a5e26f0d5",
    },
    "Welcome back": {
      hash: "6621249514b7887c",
    },
    or: {
      hash: "7175517a370b5cd2",
    },
  },
  missedPunchRequest: {
    '"Request shift payment" and follow the steps to get paid for this shift.': {
      hash: "5d78d3c01a7f3a10",
    },
    "Add the reason for missing clock in/out from the worker": {
      hash: "a082fd30d7c96141",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Clock in": {
      hash: "09adde92f00886ef",
    },
    "Clock in time": {
      hash: "8f227bc8dd1f19c3",
    },
    "Clock out": {
      hash: "45733af728fba90d",
    },
    "Clock out time": {
      hash: "e005cecbc48072c2",
    },
    "Failed to load shift details": {
      hash: "54c7049be8221356",
    },
    "Failed to submit unsigned missed punch request": {
      hash: "8016267a5d2d907d",
    },
    "Generate Unsigned Missed Punch Request": {
      hash: "1d43329e847494c8",
    },
    "It is not allowed to process a paper timesheet on this shift.": {
      hash: "caed89bf40fc2c84",
    },
    "It is not allowed to process a paper timesheet on this shift. Please ask the professional to go to Shift History":
      {
        hash: "dc5922e62a919fe5",
      },
    "MPR eligible": {
      hash: "c6f4af27d3c0ec8e",
    },
    "Missed Punch Request Required": {
      hash: "4384a9db2738d8fd",
    },
    "One of the following two cases applies: The workplace has approved this shift time increase OR the shift is not actually":
      {
        hash: "5e268c8f9361afbb",
      },
    "Please note that this shift has an approved MPR. Kindly review the details carefully before proceeding with any adjustments.":
      {
        hash: "c9c8084eb6d3d632",
      },
    "Please provide at least 30 characters": {
      hash: "02a4fc7c14fd1f99",
    },
    Reason: {
      hash: "f81ab834de5f8491",
    },
    "Reason for missed punch request": {
      hash: "fca73138f1f51921",
    },
    Submit: {
      hash: "155f816c0407310c",
    },
    "This shift has a pending Missed Punch Request. Please correct and approve or decline the MPR before making shift adjustments.":
      {
        hash: "0b69226a13ae20dd",
      },
    "To request a change for this shift, please adjust at least one time field": {
      hash: "a745945a992b3f06",
    },
    "Unsigned missed punch request submitted successfully": {
      hash: "a2578cd365b13e34",
    },
    "View Missed Punch Request": {
      hash: "57cf1b694598e578",
    },
  },
  myAccount: {
    "&#x2022;": {
      hash: "203c79fe20bbf056",
    },
    "Are you sure you want to deactivate?": {
      hash: "1b21c5e9cfc510fb",
    },
    "Are you sure you want to unlink from {{workplaceName}}?": {
      hash: "56ad18c6bbb2efc6",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Change Password": {
      hash: "a949f46230748d3f",
    },
    "Change password": {
      hash: "3f9c991f63a9a376",
    },
    "Confirm new password": {
      hash: "bf000421aeb39493",
    },
    "Current password": {
      hash: "72ed2bd767cef627",
    },
    Daily: {
      hash: "b36c2611dcdfa190",
    },
    "Daily Summary Time": {
      hash: "18ac6380138bdd5b",
    },
    "Deactivate Account": {
      hash: "1f7227ba0c569543",
    },
    "Deactivate account": {
      hash: "5e31b73d3d36bee7",
    },
    "Don't know your current password?": {
      hash: "999bd6c24bbb567c",
    },
    Edit: {
      hash: "464c4ffd019e1e96",
    },
    "Edit Personal Information": {
      hash: "a6ac8a2a2f638962",
    },
    Email: {
      hash: "969ccbd3cf6300ec",
    },
    "Failed to deactivate user": {
      hash: "312873712eff4228",
    },
    "Failed to load account details. Please try again.": {
      hash: "8fb9beb223ae544b",
    },
    "Failed to unlink user": {
      hash: "9e12da5e3227bf5d",
    },
    "Failed to update personal information": {
      hash: "5d30556f50ec96d6",
    },
    "First Name": {
      hash: "96ce6e6193a04726",
    },
    "Job Title": {
      hash: "de2c883522422d43",
    },
    Landline: {
      hash: "28ad230b46ce7f37",
    },
    "Last Name": {
      hash: "f55563b386a39dc3",
    },
    "Mobile Phone": {
      hash: "b286c7f6e0ef9fb1",
    },
    "My Account": {
      hash: "ad0187add790ff17",
    },
    Name: {
      hash: "dcd1d5223f73b3a9",
    },
    "New password": {
      hash: "3dd9df4441fb348f",
    },
    "Notification Preferences": {
      hash: "1e3564bdba890599",
    },
    Off: {
      hash: "ca7981b46ecf2c17",
    },
    On: {
      hash: "130011756125313c",
    },
    "Password changed successfully": {
      hash: "d493798b58334f24",
    },
    "Password must be at least 8 characters": {
      hash: "e3b8d09d1ac4b9f1",
    },
    "Password reset email sent to {{userEmail}}.": {
      hash: "25de2f171b5bb91f",
    },
    "Passwords do not match": {
      hash: "b6eb82cd3300c838",
    },
    "Personal Information": {
      hash: "c4b37e84b553d29b",
    },
    "Please enter a valid US landline number.": {
      hash: "b328c0544845a4f8",
    },
    "Please enter a valid US mobile number.": {
      hash: "259a1c90bc00df46",
    },
    "Please enter a valid email address.": {
      hash: "958e4ccf2953d747",
    },
    Push: {
      hash: "731ce7ed808913b2",
    },
    Retry: {
      hash: "942087cc2d41e013",
    },
    "SMS notifications are disabled because no mobile number is set. Add a mobile number in Personal Information to enable SMS notifications.":
      {
        hash: "5c81e533cbb65983",
      },
    Save: {
      hash: "1509f561f2416598",
    },
    "Send a reset email": {
      hash: "929b1b5635346bbd",
    },
    "Sending...": {
      hash: "286a3af7348e8312",
    },
    "Unlink Account": {
      hash: "3e2a22f4bbb80ade",
    },
    "Unlink from workplace": {
      hash: "d4c687a498dfad56",
    },
    "Web Push": {
      hash: "4ba2056e9ba62960",
    },
    "Your account is missing an email address. Please contact support.": {
      hash: "285e229fe9526851",
    },
    "will lose access to all associated workplaces and will no longer be able to log in.": {
      hash: "f2b1e1fd996e14eb",
    },
    "will lose access to {{workplaceName}}, but will maintain access to other workplaces:": {
      hash: "bb1d910d2ce54d39",
    },
  },
  myProfessionals: {
    All: {
      hash: "a52ace420f2175d0",
    },
    "All license types": {
      hash: "22b8701f928b506a",
    },
    "All types": {
      hash: "f10988e79e8d9a49",
    },
    "An error occurred loading person number": {
      hash: "1ebe33a7ca0e9b6a",
    },
    Apply: {
      hash: "31e392d1c0378bec",
    },
    "At your workplace": {
      hash: "4d0dccebdf232cdf",
    },
    Blocked: {
      hash: "18f2a0947f9d6523",
    },
    "Blocked by": {
      hash: "36931a940259dfe1",
    },
    "Blocked date": {
      hash: "79d05966d82ae951",
    },
    "Blocked professional": {
      hash: "6b7c6c52597851ea",
    },
    "Booked Shifts": {
      hash: "f3314dc78a3e0b64",
    },
    Break: {
      hash: "f71081fb0af48ae6",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Charting password": {
      hash: "322d4240e1f506a4",
    },
    "Charting software": {
      hash: "433edf86242299ad",
    },
    "Charting username": {
      hash: "f12dee008fc34050",
    },
    Chat: {
      hash: "460b3a7da007b7af",
    },
    "Clock in/out": {
      hash: "6e6efd60da4a33c3",
    },
    "Close booked shifts": {
      hash: "4b989bb982644a34",
    },
    Collapse: {
      hash: "be6eb1fc3b05bf9d",
    },
    Credentials: {
      hash: "d48a617c7da5163c",
    },
    "Credentials needed": {
      hash: "eceb255ef3b5061f",
    },
    "Credentials updated successfully": {
      hash: "6f1e379f2503a270",
    },
    "Credentials were updated, but the external ID could not be saved. Please retry.": {
      hash: "a64dd88e87280ca6",
    },
    "Credentials were updated, but the workplace default password could not be saved. Please retry.":
      {
        hash: "6fba4e15a1cbf99d",
      },
    "Current workplace": {
      hash: "9b18491d601d3708",
    },
    Documents: {
      hash: "b4e929d8bcfe0418",
    },
    "Edit credentials": {
      hash: "5a6622b6c936e060",
    },
    Expand: {
      hash: "07548c2c6511d4d1",
    },
    "Failed to share credentials, please try again.": {
      hash: "856e3761c64cb75a",
    },
    "Failed to update worker credentials.": {
      hash: "16f5c76194abea44",
    },
    "Filter past professionals": {
      hash: "9366db524dd21853",
    },
    "Filter upcoming professionals": {
      hash: "cd8c3f07cf2f3a40",
    },
    Filters: {
      hash: "546ebb8eb993ea56",
    },
    "First shift": {
      hash: "10995167701b917f",
    },
    "Invite staff": {
      hash: "981038b9aea98b69",
    },
    "Keep this aligned with the workplace system so the professional can start cleanly.": {
      hash: "b36d293309ceff16",
    },
    "Last shift": {
      hash: "5fbd94fab10dd609",
    },
    "Last shift worked": {
      hash: "c922464a23f03bfc",
    },
    "License type": {
      hash: "72f256afd196ceae",
    },
    "More actions": {
      hash: "f8d46c2570e70736",
    },
    "My Professionals": {
      hash: "708e415f9ac11beb",
    },
    New: {
      hash: "18fdd549b2ed367a",
    },
    "Next shift": {
      hash: "0b4243f09a2f1e18",
    },
    "No DNR records found": {
      hash: "199a694d51e3e238",
    },
    "No past professionals": {
      hash: "6c328e4982bfaf41",
    },
    "No reasons provided": {
      hash: "cc6ed3013b909ae3",
    },
    "No upcoming professionals": {
      hash: "35b50b5750239f6d",
    },
    Notes: {
      hash: "8a7525b1492fb848",
    },
    "Once starred, this professional will be highlighted in invite and chat flows when you post new shifts.":
      {
        hash: "d694eaeed5f7e39d",
      },
    "Open filters": {
      hash: "baaa3007f92b4afd",
    },
    Past: {
      hash: "ca1530e8d7017547",
    },
    "Past Professionals": {
      hash: "ec73df6c916275b0",
    },
    Professional: {
      hash: "19c73a5cdf346d96",
    },
    "Professional not onboarded yet": {
      hash: "9fb0aedc4603d8ac",
    },
    "Professionals on your DNR list cannot be added to your starred list": {
      hash: "a6a5fc451f8f8e92",
    },
    Reasons: {
      hash: "72ed245d2cf11822",
    },
    Reset: {
      hash: "daee7606b339f3c3",
    },
    "Save as workplace default password": {
      hash: "bd40133d140c53ee",
    },
    "Save credentials": {
      hash: "f412ebc3df40018a",
    },
    "Search for a professional": {
      hash: "2e71da3a95d291bc",
    },
    "Share credentials": {
      hash: "257c8051763d5f71",
    },
    "Share credentials in bulk": {
      hash: "4bd715c382a8f125",
    },
    "Star professional": {
      hash: "6497caa0b3ed4629",
    },
    Starred: {
      hash: "07a2d579c3f0d325",
    },
    "Starred professional": {
      hash: "44b23f3add41fbac",
    },
    "This professional has been blocked from your workplace.": {
      hash: "24994239b28b5d66",
    },
    "This professional has no past shifts.": {
      hash: "ca2025fdc8918fe6",
    },
    "This professional has no upcoming shifts.": {
      hash: "771fec220e68bb00",
    },
    "Toggle password visibility": {
      hash: "1016c07b0f58d365",
    },
    Unblock: {
      hash: "712da63171e0c9de",
    },
    "Unstar professional": {
      hash: "9efd44c8a075af86",
    },
    Upcoming: {
      hash: "5f1a2542e4e4ca5e",
    },
    "Upcoming Professionals": {
      hash: "58ffa3984521da53",
    },
    "View details": {
      hash: "d1bf045bb524dae5",
    },
    "View documents": {
      hash: "d0a435de6fc4a493",
    },
    "name tmz": {
      hash: "937d7af2b0a4d271",
    },
  },
  navigation: {
    "24/7 Support": {
      hash: "2bff98865447b479",
    },
    "Account Manager": {
      hash: "ccc498b77ae62cf8",
    },
    Accounts: {
      hash: "8a7c8b67fe8bde8b",
    },
    "Admin Tools": {
      hash: "af0c3ba6a2ca80ba",
    },
    Administrator: {
      hash: "e7d3e769f3f593da",
    },
    Analytics: {
      hash: "94c116ee118a7299",
    },
    "Application & Jobs": {
      hash: "d159134ea385fdbc",
    },
    "Are you sure you want to log out?": {
      hash: "8378c006e5505ccf",
    },
    Availability: {
      hash: "12f67f8539c46701",
    },
    "Badge Verification Grading": {
      hash: "92b899d39a9f6e5c",
    },
    Bans: {
      hash: "4d5469c7be3b5130",
    },
    Billing: {
      hash: "3ac8bbca9a74cfbd",
    },
    "Billing Specialist": {
      hash: "09a996ec24fb0a72",
    },
    "Browse Professionals": {
      hash: "d9e7915f59343c9b",
    },
    "Browse Talent Pool": {
      hash: "f5b152d912d4a37a",
    },
    "By Number": {
      hash: "bcc957ee4ec02126",
    },
    "By Period": {
      hash: "189d145aadfed8e7",
    },
    Calendar: {
      hash: "d5d0a30b517e3bea",
    },
    "Calendar (Classic)": {
      hash: "edad27774d43f2d1",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Candidate Profile": {
      hash: "96d96be238230962",
    },
    Cases: {
      hash: "2249bd503ec47d72",
    },
    "Change Log": {
      hash: "6fd553132e7785dc",
    },
    Charting: {
      hash: "f4d573798f5b25fe",
    },
    Chat: {
      hash: "460b3a7da007b7af",
    },
    "Clipboard Score": {
      hash: "5a639e298037569b",
    },
    "Close menu": {
      hash: "6ccd5c7856042d36",
    },
    "Confirm Log Out": {
      hash: "46d51ff0db7eb2e9",
    },
    "Contact Support": {
      hash: "f8d47b82e285ba95",
    },
    "Contract Terms": {
      hash: "be5acd2ec9bc6849",
    },
    "Copied!": {
      hash: "ea61bc15688d1e48",
    },
    "Copy details": {
      hash: "ec7ee2826c849564",
    },
    "Corporate Analytics": {
      hash: "8adad8a24dbd0f7b",
    },
    "Corporate Center": {
      hash: "daeb3a9c6c097148",
    },
    "Coverage Map": {
      hash: "ac9cde5b5bee03f3",
    },
    Current: {
      hash: "e0d1b68224bf0b31",
    },
    "Currently Viewed": {
      hash: "9839593ad1155065",
    },
    DNR: {
      hash: "9ca1816c47234807",
    },
    DNRs: {
      hash: "f6120e8981f1882f",
    },
    Eligibility: {
      hash: "dfa9dfa5cad2d8f9",
    },
    Employees: {
      hash: "c98270317b51cbb3",
    },
    Exclusions: {
      hash: "fcc9f1f929785440",
    },
    "External Photos": {
      hash: "ee1b6e3886b4d185",
    },
    "Getting started": {
      hash: "831d0f72d242b7d1",
    },
    Help: {
      hash: "b79cac926e0b2e34",
    },
    "Help Center": {
      hash: "a78cebc44214256b",
    },
    Hiring: {
      hash: "4e414af41b7d4876",
    },
    "Home Health Worker Search": {
      hash: "ff9c41ba1c875fb1",
    },
    "Interview Availability": {
      hash: "c2c3b55d9c20c18a",
    },
    "Interview Schedule": {
      hash: "3fa7a764f8ffaa77",
    },
    Interviews: {
      hash: "0b9e49cf035bd75b",
    },
    Invoice: {
      hash: "b832002da297545f",
    },
    "Invoice History": {
      hash: "8f74e5015dd26f64",
    },
    "Landing Page": {
      hash: "a93cb7c71ee33577",
    },
    "Live Worker ETA": {
      hash: "4e952b41752d7990",
    },
    "Load more workplaces": {
      hash: "d065e5b97c6f5a6b",
    },
    Locations: {
      hash: "95c61170318a2851",
    },
    "Log Out": {
      hash: "d57d48b71020b33a",
    },
    "Logging out…": {
      hash: "5a79edda3e34d40e",
    },
    Management: {
      hash: "e51248773b9a3f59",
    },
    "My Account": {
      hash: "ad0187add790ff17",
    },
    "My Internal Roster": {
      hash: "30a2860742589675",
    },
    "My Professionals": {
      hash: "708e415f9ac11beb",
    },
    "Navigation menu": {
      hash: "3f9abc8733ba366a",
    },
    "No Shows": {
      hash: "9474c5cf93f62e30",
    },
    "No records found": {
      hash: "6e2ea637b30eadce",
    },
    "No workplaces available": {
      hash: "4b4a11d469f69455",
    },
    'No workplaces match "{{searchTerm}}"': {
      hash: "c9271e487280e152",
    },
    Notifications: {
      hash: "788011833a5a0f22",
    },
    "Open search": {
      hash: "50ce48b9c623c1cd",
    },
    "Other workplaces": {
      hash: "cdf7ce7d44347fa1",
    },
    Payroll: {
      hash: "53fe8dfb6d9e1b03",
    },
    "Permanent Hiring": {
      hash: "65287dcca549e0db",
    },
    Placement: {
      hash: "4df9939944a7b324",
    },
    "Post-Invoice Disputes": {
      hash: "363d6a41a48b73a6",
    },
    "Pre-Invoice Disputes": {
      hash: "e3373cf04f80ef64",
    },
    "Professional ID": {
      hash: "38f01b3c5ffc13e3",
    },
    "Professional Name": {
      hash: "99f2b26bd7057b5b",
    },
    Professionals: {
      hash: "c8d715a6f56bac25",
    },
    Qualifications: {
      hash: "7b4339cf860e01a6",
    },
    "Recently Viewed": {
      hash: "eab19ec694a80bca",
    },
    "Recently Viewed Accounts": {
      hash: "37ae24bdf1c25cd2",
    },
    "Refer & Earn": {
      hash: "6b653f745fa52b81",
    },
    Reporting: {
      hash: "b1fa104b9bf0635e",
    },
    Requirements: {
      hash: "e0cdd07f6a270b82",
    },
    Reviews: {
      hash: "84cb7871b741c32e",
    },
    "Reviews Moderation": {
      hash: "47484938c8a87102",
    },
    "SMS Portal": {
      hash: "c7677b97318f448a",
    },
    "SSN Worker Lookup": {
      hash: "55542efef9055f03",
    },
    Schedule: {
      hash: "f4830a1dae298044",
    },
    Scraping: {
      hash: "cf38d8fe149ecdf8",
    },
    Search: {
      hash: "49c266baaaa70981",
    },
    "Search agents or workplaces": {
      hash: "c5487af5ec0de077",
    },
    "Search workplaces...": {
      hash: "a8959c978f05887f",
    },
    "Select Account": {
      hash: "d0ed4b43b56d7470",
    },
    Settings: {
      hash: "74a883a037bc227f",
    },
    "Shift Explainer": {
      hash: "372330d1b42e8de2",
    },
    "Shift Logs": {
      hash: "5c7b8d053d5b3e26",
    },
    "Shift Payments": {
      hash: "fa00fd7d75c43f54",
    },
    "Shift Search": {
      hash: "83f74582a922da01",
    },
    Shifts: {
      hash: "3c653dabeef2e3c2",
    },
    "Shifts Verification": {
      hash: "7a21f9b68442b295",
    },
    "Spend Controls": {
      hash: "9a03073fb5cf415d",
    },
    Staffing: {
      hash: "0e199ed6d6f4b783",
    },
    "Stripe Payouts": {
      hash: "db87f5ee3afa1ca9",
    },
    "Stripe Transfers": {
      hash: "85279245c3c16c92",
    },
    "Switch account (current: {{switcherTitle}})": {
      hash: "8216096dc5263713",
    },
    "Switch to admin": {
      hash: "4ab38aa0a0be3888",
    },
    "Switch workplace": {
      hash: "a29be0c28e95f23f",
    },
    "Tap to copy": {
      hash: "abefee79c9ed4bb3",
    },
    "Team Members": {
      hash: "e2204b3eaff613de",
    },
    "Timeclock Requests": {
      hash: "f2b4bd6f9b506e10",
    },
    "Timeclocking Settings": {
      hash: "881a371729ce67f0",
    },
    "Timekeeping Videos": {
      hash: "5e39688b3981234f",
    },
    "Under construction": {
      hash: "ac549c250b476176",
    },
    "Upcoming Charges": {
      hash: "a2fb237d15320535",
    },
    "View More": {
      hash: "15435b311c937143",
    },
    "Visit Verification": {
      hash: "c897635c22a67087",
    },
    "We're currently making improvements to our mobile app. When it's ready, we'll let you know!": {
      hash: "fe01dd4acbf69e7c",
    },
    "Worker Evidences": {
      hash: "8c13bf02a1a2b30e",
    },
    Workers: {
      hash: "7a1ec9fe6c3b483f",
    },
    Workplace: {
      hash: "09fd2948a8dffd21",
    },
    "Workplace Analytics": {
      hash: "63256883cad9b1a5",
    },
    "Workplace ID": {
      hash: "049245ad1f768a37",
    },
    "Workplace Information": {
      hash: "b1d3c3c3f44d8a16",
    },
    "Workplace Name": {
      hash: "216f411031cbef73",
    },
    "Workplace Requirements": {
      hash: "904b4af203bd9342",
    },
    "Workplace Rules Quiz": {
      hash: "e3c8c9b2fc87dc21",
    },
    "Workplace Types": {
      hash: "10104f72c61f60fd",
    },
    Workplaces: {
      hash: "324ddac12d893a7d",
    },
    "You will need to sign in again to access your account.": {
      hash: "26d6fb4222835ff1",
    },
  },
  orientation: {
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    Capacity: {
      hash: "ae65d096550ff4eb",
    },
    Create: {
      hash: "4759498ac2a719c6",
    },
    "Create orientation block": {
      hash: "80625961671ca1f3",
    },
    "End date": {
      hash: "14303aa0c4a08d39",
    },
    "Failed to create orientation block": {
      hash: "59568730f215c863",
    },
    "Notes for professionals (optional)": {
      hash: "a7cba5fc45cdd4cf",
    },
    "Orientation block": {
      hash: "5b4dee0fb8e18745",
    },
    "Orientation block created": {
      hash: "0b3d8801e8101ab3",
    },
    "Orientation blocks do not post to marketplace. Assignments are managed internally.": {
      hash: "ea790973625add62",
    },
    Qualification: {
      hash: "00945c89f76b547f",
    },
    "Start date": {
      hash: "8169693101a4536c",
    },
  },
  prnRoster: {
    "Add to Roster": {
      hash: "95f4e8338213e418",
    },
    "Add worker to Roster": {
      hash: "861b38f2b1ed5692",
    },
    "Are you sure you want to exit?": {
      hash: "47f25f763e0dbcfb",
    },
    "Baseline hrs": {
      hash: "18beff7fbca20740",
    },
    "Baseline weekly hours": {
      hash: "a5145b2fe67f98b4",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Cannot modify name, phone or email because this information is linked to this worker's existing Clipboard profile.":
      {
        hash: "24017c138bb440e0",
      },
    Common: {
      hash: "309955e00850b8af",
    },
    "Date added": {
      hash: "3321b9f6e65c542a",
    },
    Edit: {
      hash: "464c4ffd019e1e96",
    },
    "Edit worker": {
      hash: "290056e834ccabee",
    },
    Email: {
      hash: "969ccbd3cf6300ec",
    },
    "Email (optional)": {
      hash: "6eea8608c452711b",
    },
    "Email can't be cleared once set. Enter a new email or restore the previous one.": {
      hash: "74fa562f32ea8c7d",
    },
    "Failed to load qualifications. Please close and try again.": {
      hash: "0c370ec3af873d9e",
    },
    "Full name": {
      hash: "f13a64ba2fea87ef",
    },
    Name: {
      hash: "dcd1d5223f73b3a9",
    },
    Other: {
      hash: "f97e9da0e3b879f0",
    },
    Phone: {
      hash: "63dceb8800b2dd4a",
    },
    "Phone number": {
      hash: "306f1bb20677a622",
    },
    Qualifications: {
      hash: "7b4339cf860e01a6",
    },
    Remove: {
      hash: "c3812fc4acb861d5",
    },
    "Remove worker": {
      hash: "c08431714df238ca",
    },
    "Save changes": {
      hash: "dd0ae7a5cbcf2339",
    },
    "They will not be able to book shifts through Roster as an in-house staff member. You can re-add them at any time.":
      {
        hash: "7f58d87c3a2bc3bc",
      },
    "This worker is already in your Roster. Edit the existing record to update their information.":
      {
        hash: "7eab65b15b80284e",
      },
    "This workplace has no qualifications configured. Contact support to enable PRN roster.": {
      hash: "76dfed04f989a28b",
    },
    "We found a matching worker for {{phoneNumber}}": {
      hash: "394aac2bde696049",
    },
    "You'll lose your changes for this Roster professional.": {
      hash: "5316450fd4da39c7",
    },
    "from your Roster?": {
      hash: "78d9d31ef4d4f2ae",
    },
    "is already on Clipboard with this phone number. Add them to your Roster?": {
      hash: "a1dc12a7788084dd",
    },
  },
  pushNotifications: {
    "Chat messages": {
      hash: "4165e2978c2117ef",
    },
    "Enable notifications": {
      hash: "682be64ae7801fd0",
    },
    "Know the moment a shift is claimed or cancelled.": {
      hash: "be3df4f3d324f259",
    },
    "Maybe later": {
      hash: "2ac741e6203af759",
    },
    "Reply to professionals without keeping a tab open.": {
      hash: "dc78a7975e25749f",
    },
    "Schedule changes": {
      hash: "8a4dd392e661b037",
    },
    "Shift bookings": {
      hash: "2b194934439e9665",
    },
    "Stay on top of last-minute updates to your calendar.": {
      hash: "d735e44ede615db9",
    },
    "Stay up to date": {
      hash: "3fea642185ba9acd",
    },
    "This notification has expired": {
      hash: "bb665d949734749a",
    },
    "Turn on push notifications to get timely updates — even when the app is closed.": {
      hash: "cdd5d0719a0e47f5",
    },
  },
  rateRequest: {
    "Duplicate requests within the last {{lookBackDays}} days are not permitted.": {
      hash: "7da032c39f057ad2",
    },
    "Failed to submit rate request": {
      hash: "487347e074fb8050",
    },
    Qualification: {
      hash: "00945c89f76b547f",
    },
    "Rate request submitted. Your CSM will follow up within 1 business day.": {
      hash: "9f8669337c8da10b",
    },
    "Submit request": {
      hash: "917e144e4bc3da89",
    },
  },
  ratingPrompt: {
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Contact support": {
      hash: "814f4ed2d5bd33e3",
    },
    "Let us know how we can improve.": {
      hash: "f05abe0730c3b196",
    },
    "Sorry to hear that": {
      hash: "af015af1fd67fbdf",
    },
    "Submit feedback": {
      hash: "4a101ec79a35b0a2",
    },
    "Tell us more...": {
      hash: "a7e56c38fbd8c267",
    },
  },
  referAndEarn: {
    "Admin view": {
      hash: "5dbfc76de9a61cb2",
    },
    "Copied!": {
      hash: "ea61bc15688d1e48",
    },
    "Copy link": {
      hash: "dbf362d4f210c780",
    },
    "Created At": {
      hash: "3d44337010bfbdf7",
    },
    "Earn your referral!": {
      hash: "ad6f1f46a0d887fa",
    },
    Email: {
      hash: "969ccbd3cf6300ec",
    },
    "Failed to load referral code.": {
      hash: "117fe58fb0965b3b",
    },
    "Failed to load referrals.": {
      hash: "032062c35f0ec6c7",
    },
    Gmail: {
      hash: "d19a15c70437ed6e",
    },
    "Hi!\n\nI've been using Clipboard Health and finding it super helpful for getting access to reliable shift coverage. The signup is seamless and the app is super easy to use.\n\nI think you should sign up to Clipboard Health. I find it to be super helpful for accessing reliable shift coverage. You get access to Professional ETA, in-app chat, urgent shift replacement and more!\n\nSign up using my referral code and you'll instantly earn {{incentiveAmount}} credits once you post your first shift (the credits will apply to the first shift onward): {{referralUrl}}\n\nI think you're going to be in for a treat!\n\nAll the best,\n\n{{fullName}}":
      {
        hash: "c193a5735f1723aa",
      },
    "Incentive: {{incentive}}": {
      hash: "61cefb5ee7454e7d",
    },
    "Introduce your workplace contacts to Clipboard Health by sending them your referral link.": {
      hash: "25d092234974cd8b",
    },
    Name: {
      hash: "dcd1d5223f73b3a9",
    },
    "No referrals yet": {
      hash: "dc634dfbcce23ba4",
    },
    "Outlook / Hotmail / Live": {
      hash: "596f52c9bbfdeb6f",
    },
    "Read the terms and program requirements.": {
      hash: "6fa2f04b36ca4a14",
    },
    "Refer a new workplace": {
      hash: "4258c29ea4d12fbe",
    },
    "Referral Code": {
      hash: "f408535bacccfc1d",
    },
    "Referral Earned": {
      hash: "039f155d5e0eb4bc",
    },
    "Referral bonus": {
      hash: "664b0a5c07ecbd94",
    },
    Referrals: {
      hash: "76ffc344c6ae80b5",
    },
    Retry: {
      hash: "942087cc2d41e013",
    },
    "Send referral": {
      hash: "098f25dceaa93fbd",
    },
    "Send your personalized referral link to your workplace contacts.": {
      hash: "11fc1404d2a4c96f",
    },
    "Send your referral link to other workplaces. You can also copy the link and share it via social media or text.":
      {
        hash: "d637a2187ef38917",
      },
    "Share the referral link": {
      hash: "86a5bfa5d2dc25ff",
    },
    "Share your referral link": {
      hash: "bd2ba12499df5239",
    },
    "Shift credits": {
      hash: "7cdc830f14ab65a1",
    },
    "Sign up to Clipboard Health using my referral link!": {
      hash: "0faec61d36bda7bd",
    },
    Status: {
      hash: "920e413c7d411b61",
    },
    "Track when your contact signs up their workplace using your referral code.": {
      hash: "0355dadf5f4baffe",
    },
    "Track your referrals": {
      hash: "89f8087ecd480ef3",
    },
    "Variant: {{variant}}": {
      hash: "fe17ed8e33cb2efd",
    },
    "Workplace name": {
      hash: "a1630b6d262decc2",
    },
  },
  reporting: {
    "Booked shifts starting within the next 48 hours.": {
      hash: "c522ba8398594f8c",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    Close: {
      hash: "7d9eb7acb13e2462",
    },
    "Date Range": {
      hash: "14d74158a8d17afe",
    },
    "Email My Past Shifts": {
      hash: "1559a79d9a98cc94",
    },
    End: {
      hash: "f4db1e48476f6075",
    },
    Error: {
      hash: "54a0e8c17ebb21a1",
    },
    "Export Past Shifts": {
      hash: "f11f7b221d0149fa",
    },
    "Lifetime Clipboard Shifts": {
      hash: "ee89233169887439",
    },
    "Lifetime Contracted Professionals": {
      hash: "6581fd2fc435ddf1",
    },
    "Next 48 hours.": {
      hash: "868dd3bb3de9cd6d",
    },
    "Next page": {
      hash: "c08ac736a5e29c29",
    },
    "No chart data is available for this workplace yet.": {
      hash: "0a0576d381558739",
    },
    "No shifts available for this view right now.": {
      hash: "18e83b61f2fd9ee7",
    },
    "No shifts were found in the selected date range.": {
      hash: "32334126e7a4727b",
    },
    "Open My Professionals": {
      hash: "c0bbbd310ce1d6a3",
    },
    "Open coverage needs in the next 48 hours.": {
      hash: "d56bd8d171bea796",
    },
    "Page {{page}}": {
      hash: "aaf89a2e8dd2e9c7",
    },
    "Page {{page}} of {{totalPages}}": {
      hash: "abf8fcb96d8d7ccb",
    },
    "Performance Trends": {
      hash: "f308f941bd16022b",
    },
    "Previous page": {
      hash: "1208ec01f223c616",
    },
    Professional: {
      hash: "19c73a5cdf346d96",
    },
    Reporting: {
      hash: "b1fa104b9bf0635e",
    },
    "Reports include the start and end dates selected, unique professional IDs, daily hours with midnight splits, and the rest of the existing export payload.":
      {
        hash: "9d9afc4eb9108e8d",
      },
    "Request a CSV for any time period and get the same full export payload as the legacy workflow, including unique professional IDs and day-by-day hours.":
      {
        hash: "50ca140508e4c2fe",
      },
    "Request export": {
      hash: "c2b7ea6e50679e34",
    },
    "Request report": {
      hash: "7f6ef2a4b8b68158",
    },
    Shift: {
      hash: "2e544a292f6979ed",
    },
    Start: {
      hash: "e4bb9f1ece9af926",
    },
    "There was an error generating your report. Please try again or contact support.": {
      hash: "3aaa8e968bd46b42",
    },
    "Total Clipboard shifts completed at this workplace.": {
      hash: "3c81e27e32356966",
    },
    "Unique professionals who have already worked here.": {
      hash: "34c4406f444e3055",
    },
    "Upcoming Filled Shifts": {
      hash: "b70c92965b2bef81",
    },
    "Upcoming Unfilled Shifts": {
      hash: "bcd892c6af2e7a95",
    },
    "Use export to inspect the full history": {
      hash: "84a6279baecd797d",
    },
    "We could not load reporting trends right now.": {
      hash: "3e69ed92dacf9336",
    },
    "We couldn't load this metric right now.": {
      hash: "b9f85f36d4fd1e96",
    },
    "We'll generate a CSV for the selected period and email it to the address associated with your account.":
      {
        hash: "f00b68c521eff8c8",
      },
    "Week of shift start": {
      hash: "7c7523eda3b9df7e",
    },
    "Weekly fill, last-minute demand, and dynamic charge outcomes.": {
      hash: "29ccb51a8ac08325",
    },
    "What you'll get": {
      hash: "010077a338ae711d",
    },
    "Your report will be emailed to you in just a few minutes.": {
      hash: "730fa2bbb7eed5be",
    },
  },
  requiredDocuments: {
    Added: {
      hash: "6b02e0d363a4af1c",
    },
    "Additional info": {
      hash: "38dcdfef0e61dc47",
    },
    "All Professional Types": {
      hash: "e01f7ad88a2c280e",
    },
    "All professionals": {
      hash: "923b95b59c0fb208",
    },
    Apply: {
      hash: "31e392d1c0378bec",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Close viewer": {
      hash: "7b25a882e9bc3515",
    },
    "Contact email": {
      hash: "6d7fce11ae006a0d",
    },
    "Contact name": {
      hash: "ddec0fc313b40614",
    },
    "Contact phone number": {
      hash: "92eee4a4930f5e8e",
    },
    "Document details": {
      hash: "1d958732b88a662e",
    },
    Download: {
      hash: "d6eafe8235910042",
    },
    Email: {
      hash: "969ccbd3cf6300ec",
    },
    "Email is required": {
      hash: "aae9291101244de9",
    },
    "Enter full name": {
      hash: "8cc4f0417f69ea68",
    },
    "Failed to submit request. Please try again.": {
      hash: "00c6dcd85ab3df6e",
    },
    "Fewer requirements often means better fill. If you no longer need a requirement, click": {
      hash: "cee3bce87ee11bce",
    },
    Filters: {
      hash: "546ebb8eb993ea56",
    },
    License: {
      hash: "c011d6097bfbc8e9",
    },
    "Make updates to this document": {
      hash: "711482aaefbfae1f",
    },
    Name: {
      hash: "dcd1d5223f73b3a9",
    },
    "Name is required": {
      hash: "604fd1b2e29c688a",
    },
    "No document found.": {
      hash: "7391d98650ee8931",
    },
    "Only workplace can make updates": {
      hash: "1ca1a8abbdf0992d",
    },
    "Open filters": {
      hash: "baaa3007f92b4afd",
    },
    "Our operations team will review your request and get back to you soon.": {
      hash: "04ab54130564549c",
    },
    "Phone number": {
      hash: "306f1bb20677a622",
    },
    "Phone number is required": {
      hash: "bebb152dbd4eb6ff",
    },
    "Please enter a valid US phone number": {
      hash: "36094873f44f5122",
    },
    "Please enter a valid email address": {
      hash: "b00f7e3ae5e87365",
    },
    "Please provide additional details": {
      hash: "05486965a07f6572",
    },
    Print: {
      hash: "df0fe79898ef413e",
    },
    "Professional Type": {
      hash: "d06001d656b14482",
    },
    "Professional Type(s)": {
      hash: "398521f2d7a62128",
    },
    "Professional Type:": {
      hash: "997605105c518f21",
    },
    "Professionals upload their document to fulfill this requirement. There is no standard template.":
      {
        hash: "bc4ff1d271199403",
      },
    "Required for": {
      hash: "8158c43ffa300840",
    },
    Reset: {
      hash: "daee7606b339f3c3",
    },
    "Scroll professional types left": {
      hash: "1f9da3aec076bf42",
    },
    "Scroll professional types right": {
      hash: "896607755f418e25",
    },
    "Search for a document": {
      hash: "6fddc235cee48e78",
    },
    Submit: {
      hash: "155f816c0407310c",
    },
    Update: {
      hash: "c1c1009d3f37ec05",
    },
    "Update requirement": {
      hash: "c9fe2289b6dfbc06",
    },
    View: {
      hash: "dcc839a4015c4b7d",
    },
    "View document": {
      hash: "b5b8cb11a02602cf",
    },
    "What changes do you want to make?": {
      hash: "28e313dc7a8695ee",
    },
    "Who should we reach out to in order to discuss changes you want to make to this document?": {
      hash: "8b8840b5dc4573bf",
    },
    "Workplace Requirements": {
      hash: "904b4af203bd9342",
    },
    "and we can help you remove it.": {
      hash: "d96d347df6729e47",
    },
  },
  requirementV2: {
    "Are you sure you want to delete this requirement mapping?": {
      hash: "af0cc56d596d8af1",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Comma-separated": {
      hash: "bc77090e3672e182",
    },
    "Comma-separated (e.g. CA, NY)": {
      hash: "44c2b1dce3f01022",
    },
    "Confirm Delete": {
      hash: "a7f54311a3e625f5",
    },
    "Copied!": {
      hash: "ea61bc15688d1e48",
    },
    "Copy ID": {
      hash: "72ac0d580f8c4f9f",
    },
    Create: {
      hash: "4759498ac2a719c6",
    },
    "Create Evidence Definition": {
      hash: "342ec60b8c1dff58",
    },
    "Create Requirement": {
      hash: "aef35920b0ee1fe4",
    },
    "Create Requirement Mapping": {
      hash: "3fb1cfbfaa6ad97d",
    },
    "Create Standard": {
      hash: "1de9540a2246bab3",
    },
    "Created At": {
      hash: "3d44337010bfbdf7",
    },
    "Delete requirement mapping": {
      hash: "bc5078ce1707e013",
    },
    "Display Name": {
      hash: "18d67c992b71ce69",
    },
    Domain: {
      hash: "79fa33618d8eaa1f",
    },
    "Edit Evidence Definition": {
      hash: "44eee0ddd2f5ece7",
    },
    "Edit Requirement": {
      hash: "53ceaa5f5473b180",
    },
    "Edit Requirement Mapping": {
      hash: "f02530118b8acd1f",
    },
    "Edit Standard": {
      hash: "2edb1386b3a284e6",
    },
    "Edit requirement mapping": {
      hash: "395e06accb3b958a",
    },
    Eligibility: {
      hash: "dfa9dfa5cad2d8f9",
    },
    "Evidence Definition": {
      hash: "1a83135d903dcd9e",
    },
    "Evidence Definition ID": {
      hash: "4a0576c388cfaa8d",
    },
    "Evidence Definitions": {
      hash: "f8fb2c2f8b31f897",
    },
    "Failed to create evidence definition.": {
      hash: "73699fd80111c515",
    },
    "Failed to create requirement mapping.": {
      hash: "613f183e222fd273",
    },
    "Failed to create requirement.": {
      hash: "4327226d25f9321e",
    },
    "Failed to create standard.": {
      hash: "457a8abce0db81a9",
    },
    "Failed to delete evidence definition.": {
      hash: "35216c7957ee3dcd",
    },
    "Failed to delete requirement mapping.": {
      hash: "af581b30eecddefc",
    },
    "Failed to delete requirement.": {
      hash: "415bee5a77bb8213",
    },
    "Failed to delete standard.": {
      hash: "e092e70a533f66c5",
    },
    "Failed to load evidence definitions. Please try again.": {
      hash: "fea31386a31f34c6",
    },
    "Failed to load requirement mappings. Please try again.": {
      hash: "21086aa64ca25c43",
    },
    "Failed to load requirements. Please try again.": {
      hash: "0268986f0d48cdea",
    },
    "Failed to load standards. Please try again.": {
      hash: "fd5c7b4d434ccac3",
    },
    "Failed to update evidence definition.": {
      hash: "193e54a750c539da",
    },
    "Failed to update requirement mapping.": {
      hash: "7785223c0510e454",
    },
    "Failed to update requirement.": {
      hash: "57b184937623d3b1",
    },
    "Failed to update standard.": {
      hash: "75f976a7fc65f13b",
    },
    "Format JSON": {
      hash: "5ac94805281790ee",
    },
    ID: {
      hash: "3843971dcfdee508",
    },
    "ID: {{id}}": {
      hash: "e87ced5e089eba2b",
    },
    "Invalid JSON": {
      hash: "f60c824125e6408e",
    },
    "Mapping ID": {
      hash: "1004a057d2b7267e",
    },
    "No evidence definitions found": {
      hash: "6e9a4c33b916d1a4",
    },
    "No requirements found": {
      hash: "be049398d39842a1",
    },
    "Property Schema": {
      hash: "c90910730b8f8383",
    },
    "Qualification Names": {
      hash: "f0720d29ce24b75c",
    },
    Qualifications: {
      hash: "7b4339cf860e01a6",
    },
    Requirement: {
      hash: "f5f5690b0ecc41d3",
    },
    "Requirement Mappings": {
      hash: "20ee055ad1ee378d",
    },
    Requirements: {
      hash: "e0cdd07f6a270b82",
    },
    "Requires Migration": {
      hash: "84453e47975d03d7",
    },
    "Rules (ConditionTreeNode)": {
      hash: "c9a6fb6ee34fe03a",
    },
    Save: {
      hash: "1509f561f2416598",
    },
    Scope: {
      hash: "b073f6c68ef87211",
    },
    "Search by name...": {
      hash: "ed82cf60e617eb63",
    },
    "Searching evidence definitions...": {
      hash: "ed71fe3a468e163d",
    },
    "Searching requirements...": {
      hash: "88bea99c51ccc355",
    },
    Stages: {
      hash: "3a17aa4e4abb73f6",
    },
    Standards: {
      hash: "b9a136292f4004e2",
    },
    "Standards (StandardsTreeNode)": {
      hash: "c9f120c13bc3f754",
    },
    "Start typing to search": {
      hash: "3cc8ca5ee96f7abe",
    },
    "Start typing to search evidence definitions": {
      hash: "356358348d9a0262",
    },
    States: {
      hash: "2f6e9daec8e9b3b3",
    },
    "Updated At": {
      hash: "e35c8e4f5cb5c554",
    },
    "Workflow Type": {
      hash: "8a0e8b2844975daa",
    },
    "Workplace IDs": {
      hash: "1ff7e2672da736d7",
    },
    "Workplace Types": {
      hash: "10104f72c61f60fd",
    },
  },
  schedule: {
    " from your ": {
      hash: "92aa4b51d483db30",
    },
    " max": {
      hash: "48d1d231845ef108",
    },
    "&middot;": {
      hash: "7173e79ec9298b9d",
    },
    "(add)": {
      hash: "0759437ec2b49a2f",
    },
    "(remove)": {
      hash: "d64bad115a57a139",
    },
    ". How long should professionals be able to book this shift?": {
      hash: "47181cce0990730f",
    },
    ". If not, please forward this link to the person at your organization who should sign.": {
      hash: "3151c8d8f3418084",
    },
    "72 hours post suspension": {
      hash: "64b66898bb10ed0e",
    },
    Accept: {
      hash: "89713b9c9c1b8f65",
    },
    "Accept Rate": {
      hash: "b68d849723673e57",
    },
    "Accept {{payRate}}/hr from {{workerName}}?": {
      hash: "dd98fb3f6ec2f773",
    },
    "Account pending": {
      hash: "3d1b86d01a167687",
    },
    "Account suspended": {
      hash: "cb35a570b6e4baa6",
    },
    "Account suspended for missing payments": {
      hash: "e9140d190970aa34",
    },
    "Account usage temporarily paused": {
      hash: "3169d6942414f3b0",
    },
    "Acknowledge the late cancellation fee to proceed": {
      hash: "21821f4dd188bf0b",
    },
    "Action Needed: Your contract requires a signature to avoid service interruptions.": {
      hash: "18b5c627fdd66dff",
    },
    "Action needed: please ensure your contract details are up-to-date by {{deadline}}": {
      hash: "30c80016cf2cca67",
    },
    "Add a note about this cancellation": {
      hash: "61f4fb5b61e0a8fd",
    },
    "Add any additional information that you want to share with the professional about this block.":
      {
        hash: "32f665851af6351c",
      },
    "Add information": {
      hash: "06c578f913653c48",
    },
    "Add internal note": {
      hash: "b617615f96e8228c",
    },
    "Add multiple shifts": {
      hash: "9db29e4b9988dc6f",
    },
    "Add one {{slotLabel}} shift on {{dateLabel}}": {
      hash: "9f48f1c96fafcc8a",
    },
    "Add or remove at least one shift before submitting": {
      hash: "5aa786bd3cbe7854",
    },
    "Add shift": {
      hash: "bfcd93723edb6e2e",
    },
    "Add shift note": {
      hash: "572d42d7e335492c",
    },
    "Add shifts mode": {
      hash: "10b724964a717d29",
    },
    "Add to Do Not Return list": {
      hash: "fc7b2579f42a3c64",
    },
    "Add {{slotLabel}} shift": {
      hash: "d08a6f77815f3a67",
    },
    "Add {{slotLabel}} shift to block": {
      hash: "f929f2c4c375f54e",
    },
    "Add {{workerName}} to Do Not Return list": {
      hash: "d97968b23b2ee87b",
    },
    "Adding {{qualificationLabel}} shifts": {
      hash: "83a03d5fe0e91d5a",
    },
    "Additional details": {
      hash: "00fcfc375119aa6d",
    },
    "Additional details (optional)": {
      hash: "d3eefb6a33d18b7e",
    },
    All: {
      hash: "a52ace420f2175d0",
    },
    "All future shifts after {{suspensionDate}} are canceled and you can't post any new shifts. Please contact support for assistance.":
      {
        hash: "231d5ad2f40c41b6",
      },
    "All shifts": {
      hash: "95e445f6311803b9",
    },
    "All shifts after {{suspensionDate}} are canceled, and new shifts can't be posted. Please submit a payment or contact us at billing@clipboardhealth.com for assistance.":
      {
        hash: "d6f0922393cee1c1",
      },
    "All upcoming shifts for the shift block have been cancelled": {
      hash: "fd34be170e1eabc0",
    },
    "All upcoming shifts for the shift block have been removed": {
      hash: "94db8329fecc5718",
    },
    "All {{totalShifts}} filled": {
      hash: "82d1af9a1ba4f3ad",
    },
    "An unexpected error occurred": {
      hash: "6615bf1c8fddf2fb",
    },
    "Any qualified professional can book": {
      hash: "8bb5c11f9e2c57a9",
    },
    "Applying changes": {
      hash: "3a962c2d16deec6e",
    },
    "Are you sure you want to cancel this {{shiftCount}}-shift block from {{dateRange}}?": {
      hash: "7bb59e6f16e56dda",
    },
    "Are you sure you want to remove this {{shiftCount}}-shift block from {{dateRange}}?": {
      hash: "aa4341053cc3c078",
    },
    "Ask an admin or corporate decision maker to enable Variable Charge for your workplace.": {
      hash: "1bf94bc3f4fcb496",
    },
    "Ask your facility admin to add or remove professional types": {
      hash: "553a4a75b246d634",
    },
    "At least one worker type must be visible.": {
      hash: "963a5fc0081a9f94",
    },
    "Attendance Warning": {
      hash: "23fa2712b869a919",
    },
    "Available Professionals": {
      hash: "0d8cc6461b0c6858",
    },
    Back: {
      hash: "76900f1bfd16c8d4",
    },
    "Base rate": {
      hash: "51617bc0fa10901f",
    },
    "Base {{baseCharge}} · Pay +{{payDelta}} · Charge +{{chargeDelta}} →": {
      hash: "a22f7d394ae4188b",
    },
    Block: {
      hash: "211d0bb8cf4f5b52",
    },
    "Block / DNR": {
      hash: "e9d5e587f2818276",
    },
    "Block ID:": {
      hash: "6f92dd1d3de72e35",
    },
    "Block posting": {
      hash: "6952ce3ec3574335",
    },
    "Blocked Professional": {
      hash: "f8b506de10564a0c",
    },
    Book: {
      hash: "909cb81127c5e194",
    },
    "Book one worker for consecutive days as an all-or-nothing block.": {
      hash: "4a0df895879bfb77",
    },
    "Book {{workerName}} for this shift?": {
      hash: "7cb0b1ba74933007",
    },
    "Bookable until: {{time}}": {
      hash: "5ffcf02ce5a74f9e",
    },
    "Boost again": {
      hash: "b6099513e753b3e6",
    },
    "Boost rate": {
      hash: "8918efd027c62b04",
    },
    "Boost this shift": {
      hash: "a93bcdae603b8047",
    },
    Bulk: {
      hash: "3140100df131cf30",
    },
    "Bulk posting": {
      hash: "35acb87b3b3529db",
    },
    "Bulk posting complete": {
      hash: "f8e47f10d5dc8923",
    },
    "Bulk posting failed": {
      hash: "cfa969c682dfd6e6",
    },
    "Calendar & Filters": {
      hash: "dcacb8cfa6feed47",
    },
    "Calendar view mode": {
      hash: "524509f2506a2d08",
    },
    "Can you describe what happened?": {
      hash: "a2b280cfc9dde794",
    },
    "Can you tell us what happened?": {
      hash: "4127d13bb9dac63a",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Cancel Invite": {
      hash: "bd4f680faabab58b",
    },
    "Cancel Shift": {
      hash: "1737c4c244195b71",
    },
    "Cancel block": {
      hash: "119a718f0a036cbe",
    },
    "Cancel block?": {
      hash: "648ee100798ed22c",
    },
    "Cancel filled shift": {
      hash: "e3d375c44fd8439c",
    },
    "Cancel shift": {
      hash: "6b85d437dab6a01d",
    },
    "Cancel shift invite": {
      hash: "a9faf11e6bd5bec7",
    },
    "Cancel unbooked shift": {
      hash: "0ddf1900b671e408",
    },
    "Cancel {{workerFirstName}} & shift": {
      hash: "08ebafa103c2961e",
    },
    "Cancel {{workerFirstName}} and shift": {
      hash: "ded82aa591619802",
    },
    "Canceled shift": {
      hash: "30f7b875a0165505",
    },
    "Canceled shift ($)": {
      hash: "e6f4e5011fc9f121",
    },
    "Cannot send invites": {
      hash: "bb55bf0aa5b6e211",
    },
    "Charge Rate": {
      hash: "b4aba91e4f554b31",
    },
    "Charge rate": {
      hash: "cad7947500ea2aaf",
    },
    "Charge rate updated successfully": {
      hash: "c335224245004da8",
    },
    "Charge {{totalCharge}}/hr exceeds {{stateCode}}max {{maxCharge}}/hr": {
      hash: "c088da77a7c4a41f",
    },
    Chat: {
      hash: "460b3a7da007b7af",
    },
    "Choose which professional types are visible on the calendar for all users at this workplace.":
      {
        hash: "c2e06d2bdfe3244f",
      },
    "Clear all": {
      hash: "29a390f9237e3c84",
    },
    "Clear {{slotLabel}} shifts on {{dateLabel}}": {
      hash: "5e1518bc8f5b7460",
    },
    "Click a calendar slot to stage a shift in this block. You need at least two to post.": {
      hash: "55b6b511e5c3158e",
    },
    "Clipboard prohibits discrimination based on gender. By continuing, you confirm that this gender requirement is necessary to meet privacy or personal needs of the service recipients, in accordance with our":
      {
        hash: "164e553118ec7fec",
      },
    "Clock in": {
      hash: "09adde92f00886ef",
    },
    "Clocked in {{time}}": {
      hash: "6c7b0e7ddfb18671",
    },
    "Clocked out {{time}}": {
      hash: "bbb0da2768b15762",
    },
    Close: {
      hash: "7d9eb7acb13e2462",
    },
    "Close add shifts": {
      hash: "450538c1602e67c7",
    },
    "Close day panel": {
      hash: "7229bffa105473fa",
    },
    "Close invite drawer": {
      hash: "8d75f799b447a218",
    },
    "Close shift block details": {
      hash: "c6a473c0b60eab88",
    },
    "Close shift details": {
      hash: "22e56381a7a2679d",
    },
    "Close shift log": {
      hash: "2f0114c6e138bd7e",
    },
    "Close sidebar": {
      hash: "17e28e2302175d33",
    },
    Collapse: {
      hash: "be6eb1fc3b05bf9d",
    },
    "Collapse fill progress": {
      hash: "3e6983428ed0aa6c",
    },
    "Configure block": {
      hash: "fb3976bbbd316226",
    },
    Confirm: {
      hash: "eebdd24a77d9ad32",
    },
    "Contact Clipboard": {
      hash: "5a365d43779e1354",
    },
    "Contact support": {
      hash: "814f4ed2d5bd33e3",
    },
    Continue: {
      hash: "31fbef162594de01",
    },
    "Continue anyway": {
      hash: "873567be309f124e",
    },
    "Copied!": {
      hash: "ea61bc15688d1e48",
    },
    Copy: {
      hash: "e21f935f11d7e966",
    },
    "Copy to clipboard": {
      hash: "b749e205302cc219",
    },
    "Could not cancel the shift block. Please try again.": {
      hash: "c460db5e7ffae1dc",
    },
    "Could not load shift block details.": {
      hash: "d3074e49b63e8eea",
    },
    "Could not remove the shift block. Please try again.": {
      hash: "604bb026660c00eb",
    },
    "Create a block of shifts": {
      hash: "3c9d9544c83915b4",
    },
    "Currently on Do Not Return list": {
      hash: "813dbaacd7d32e4a",
    },
    "Currently required before booking": {
      hash: "25a665e3b1181d73",
    },
    "DNR {{workerFirstName}}": {
      hash: "5dd0686817487f6c",
    },
    "DNR {{workerFirstName}} and un-assign from shift?": {
      hash: "72058919d1f2d512",
    },
    DOB: {
      hash: "b758a5f34167b9cd",
    },
    Day: {
      hash: "8f2364e11b8be3ff",
    },
    Decline: {
      hash: "a2d285b352873457",
    },
    "Declined invite": {
      hash: "8ad5acfe0b6db645",
    },
    "Decrease rate": {
      hash: "9c7502853539b248",
    },
    "Delete this shift? It will be removed from your internal Roster and Clipboard (if posted).": {
      hash: "b753927f1b81553b",
    },
    "Describe the issue": {
      hash: "e708aa6b31284129",
    },
    "Describe what happened": {
      hash: "21edde0b34ffe68f",
    },
    "Discard shift draft?": {
      hash: "fcd44004d62fa8ea",
    },
    "Dismiss available workers panel": {
      hash: "f26e99281ea8898f",
    },
    "Dismiss banner": {
      hash: "ea8c089e16a3de62",
    },
    "Do Not Return": {
      hash: "f4b4637b4395a437",
    },
    "Do you want": {
      hash: "1028b375c3e16096",
    },
    "Do you want to proceed with posting this shift?": {
      hash: "2831c2ddc70ba1ad",
    },
    "Do you want to proceed with posting {{subject}}?": {
      hash: "c8c1b56f18d10c2d",
    },
    "Do you want to proceed with sending this invite?": {
      hash: "7bf1d1ae493c65f4",
    },
    "Document requirements": {
      hash: "050eb4ea88bb108f",
    },
    Documents: {
      hash: "b4e929d8bcfe0418",
    },
    Done: {
      hash: "11a6767d5674c7e4",
    },
    Download: {
      hash: "d6eafe8235910042",
    },
    Draft: {
      hash: "ebf12ef47cf575b3",
    },
    Edit: {
      hash: "464c4ffd019e1e96",
    },
    "Edit Shift Types": {
      hash: "6d18fcf56e18907d",
    },
    "Edit charge rate": {
      hash: "ee82285b2bef5f54",
    },
    "Edit shift note": {
      hash: "b7c0d007120b9767",
    },
    "Edit shift time": {
      hash: "f7c233114080719b",
    },
    "Edit time": {
      hash: "59ebe97eedd6795e",
    },
    "Edit {{qualification}} shift times": {
      hash: "d7ac4069df5d4780",
    },
    "Edit {{slotLabel}} shift times - {{dayLabel}}": {
      hash: "0f7a05f2d2b6420f",
    },
    "Edit {{slotLabel}} shift times on {{dateLabel}}": {
      hash: "9bee0cca8c8afc57",
    },
    "Edit {{slotLabel}} shift times on {{dateLabel}} (custom)": {
      hash: "dd290a557b7edd34",
    },
    Email: {
      hash: "969ccbd3cf6300ec",
    },
    "Enable Smart Pricing": {
      hash: "273a586f155caa70",
    },
    "Enable Variable Charge to encourage healthcare professionals to book shifts during {{eventName}}. Once enabled, you can edit rates directly from shift actions.":
      {
        hash: "40b70bd43b31ecbb",
      },
    "Enable Variable Charge to help fill shifts during {{eventName}}. You can edit rates directly from shift actions.":
      {
        hash: "a55076cebaa7f342",
      },
    "Enable block booking": {
      hash: "77df31107c9cd6a2",
    },
    "Enable instant book": {
      hash: "832c49d5487a2b06",
    },
    "Enable priority access": {
      hash: "ce48147aa61ee906",
    },
    "End Negotiation": {
      hash: "d5147e7b7ca9eb2e",
    },
    "End negotiation with {{workerName}}?": {
      hash: "4465be0af1a9e4b3",
    },
    "End time": {
      hash: "2e46006a5eebb262",
    },
    "Enter rate": {
      hash: "d07dd878a6dec3b7",
    },
    "Enter reason for removing from DNR list...": {
      hash: "4f21b405bd6be3b1",
    },
    "Error loading timesheet": {
      hash: "76eff1e784e83cf5",
    },
    "Error printing timesheets": {
      hash: "ef80bb8ce97b8d1d",
    },
    "Exit block posting": {
      hash: "2f5354e56825ae7f",
    },
    "Exit bulk posting": {
      hash: "17c8d95161a70ad9",
    },
    Expand: {
      hash: "07548c2c6511d4d1",
    },
    "Expand fill progress": {
      hash: "b8e9fce9abb5b491",
    },
    "Expected {{time}}": {
      hash: "439c9e0014d79dcb",
    },
    "Expired invite": {
      hash: "545aeab0cb25f867",
    },
    "Extend bookability": {
      hash: "1f6738ae6725e558",
    },
    "Extra hourly charge": {
      hash: "00a1c21554fb52f6",
    },
    "Failed to add professional to the Do-Not-Return list.": {
      hash: "3778a9b61578a0d5",
    },
    "Failed to add worker to DNR list": {
      hash: "a4814914c30ae9fe",
    },
    "Failed to clock in": {
      hash: "2057a5d5682b3170",
    },
    "Failed to create block": {
      hash: "802ab5569606ed0d",
    },
    "Failed to create shifts": {
      hash: "e1cd25b85547bd46",
    },
    "Failed to load charge rate limits": {
      hash: "d2c25c86582dcca3",
    },
    "Failed to load shifts. Please try again.": {
      hash: "e46f0ad78f6d48fa",
    },
    "Failed to remove Roster shift. Please try again.": {
      hash: "c136428eb4f99a17",
    },
    "Failed to remove worker from DNR list": {
      hash: "3d0b55c963bda776",
    },
    "Failed to send proposal. Try again.": {
      hash: "98917ffe0f77381a",
    },
    "Failed to send shift time proposal": {
      hash: "fb8108ee5a3955b5",
    },
    "Failed to update charge rate": {
      hash: "8734ab3e91d7adb4",
    },
    "Failed to update shift note": {
      hash: "958020550633c6c7",
    },
    "Failed to update shift times": {
      hash: "69774c6c1c99615a",
    },
    "Failed to update shift types. Please contact Clipboard Health support if this issue persists.":
      {
        hash: "61088da4a61587a7",
      },
    "Failed to update worker type visibility": {
      hash: "c1b116d9c6461f6a",
    },
    "Fill Guarantee applied": {
      hash: "89bf5c6461335cb0",
    },
    "Fill in-progress": {
      hash: "c83fe38303acb6ad",
    },
    "Fill shifts faster by making document requirements optional": {
      hash: "56885bbb2cfcb446",
    },
    "Filter shift types": {
      hash: "102942783e52049d",
    },
    "Finding a replacement...": {
      hash: "2f3ad8a786e16944",
    },
    "Finish signing up": {
      hash: "7d0bd0942884cd45",
    },
    "Found {{count}} professional": {
      hash: "c799e3d57799950e",
    },
    "Found {{count}} professionals": {
      hash: "afb9da9df3ada8ad",
    },
    Fr: {
      hash: "eed8f901692d0856",
    },
    Fri: {
      hash: "66dab40cea1dea5c",
    },
    "Go back": {
      hash: "6aadac2f2b7a6b8e",
    },
    "Go to today": {
      hash: "75d83f7682f56a52",
    },
    "Has active shifts in the next 2 weeks": {
      hash: "5ad1562de87b82a2",
    },
    "Helpful information for professional (optional)": {
      hash: "b96a6050465ef6df",
    },
    Hidden: {
      hash: "7e6fefff0f0aeb6c",
    },
    "Hide sidebar": {
      hash: "d1db29ebc76d9f61",
    },
    "Hourly bonus": {
      hash: "4be6397cfd627ad0",
    },
    "How do you want to apply this time change?": {
      hash: "7d9d83e30ac123f3",
    },
    "I understand that I will be charged a": {
      hash: "5fc0b4a20d784166",
    },
    "I understand that marking the professional a No Show will result in an account restriction.": {
      hash: "c2d9845f4dbeec1e",
    },
    "If not accepted, post as open shift": {
      hash: "f8d399737b4e2b24",
    },
    "If the invited professional doesn't accept the shift within the invite expiration time, the shift will automatically be posted to the marketplace as an open shift for other qualified professionals to claim.":
      {
        hash: "5e6bda48493c209d",
      },
    "If we fill the shift at a lower rate, you get the savings back! Easy as that.": {
      hash: "4d573631a40f8ee6",
    },
    "If you need help, please call operations at {{supportTelephone}} or": {
      hash: "11d1eaa116c5ddcb",
    },
    "If you're authorized to sign this contract, please do so": {
      hash: "f42dfa382dc36c83",
    },
    "If your goal is to remove {{workerFirstName}} from the shift, you can DNR {{workerFirstName}}, which will un-assign them and keep the shift open for other professionals to book.":
      {
        hash: "03c78b094b9e6759",
      },
    "Important!": {
      hash: "055881ac6763cba0",
    },
    "Important: Advise the facility callers that shifts cannot be posted by Clipboard users, or within Clipboard and must be posted in Staff Lion only.":
      {
        hash: "370c0a0b15a21184",
      },
    "Increase rate": {
      hash: "59bee529e6a259c3",
    },
    Invite: {
      hash: "1fd9ae1607aa3d80",
    },
    "Invite sent": {
      hash: "b40a57c0c9b17557",
    },
    "Invited:": {
      hash: "7b05e32e8323fa92",
    },
    "Keep block": {
      hash: "e11f44d32d49dfd2",
    },
    "Keep shift": {
      hash: "465e891b9fe6509d",
    },
    "Last shift: {{lastShiftDate}}": {
      hash: "2b7d8d67147ad7cf",
    },
    "Loading cancellation details...": {
      hash: "1a0f5183da04119b",
    },
    "Loading shifts...": {
      hash: "897a71d5318d675b",
    },
    "Maintain Coverage During Memorial Day Weekend": {
      hash: "ca473770db3a6529",
    },
    "Maintain Coverage During the Winter Storm": {
      hash: "159c9a4771cb8656",
    },
    "Make document requirements optional": {
      hash: "f23e6c26374bbc50",
    },
    Man: {
      hash: "20fe1bd201cd900b",
    },
    "Max rate": {
      hash: "da412499d3a8c4d2",
    },
    "Memorial Day Weekend": {
      hash: "a4516904313c6ff4",
    },
    "Memorial Day Weekend Coverage": {
      hash: "646662c9cc44caf4",
    },
    "Men only": {
      hash: "f16a947f6c0952a4",
    },
    "Min rate": {
      hash: "b578f4df5f37b03f",
    },
    "Missing documents:": {
      hash: "a08c01726fe761a1",
    },
    Mo: {
      hash: "d23e867e38e89ebf",
    },
    Mon: {
      hash: "f40d7f51f69edfaf",
    },
    Month: {
      hash: "310ca503ef36f177",
    },
    "More information": {
      hash: "09f6242266631e82",
    },
    "More options": {
      hash: "bc79cdffbaa8df09",
    },
    "Negotiation history ({{proposalCount}} proposal)": {
      hash: "67a1f8442ee4a6a7",
    },
    "Negotiation history ({{proposalCount}} proposals)": {
      hash: "46b70ac20134bbd7",
    },
    "New to your workplace": {
      hash: "329824d70f5d0cb1",
    },
    Next: {
      hash: "1ff57a29d7c9d11b",
    },
    "Next date": {
      hash: "259f577df539d7cd",
    },
    "Next month": {
      hash: "74e53211fef4b4d4",
    },
    "No available professionals found.": {
      hash: "f731562ef07f6f72",
    },
    "No cancellation fee": {
      hash: "b8c23620ff8c635e",
    },
    "No professional types are included in your contract yet. Please contact support to update your contract.":
      {
        hash: "d6df29adae3ef050",
      },
    "No professionals found matching your search.": {
      hash: "1e06ac23b9c0ef5b",
    },
    "No replacement requested": {
      hash: "99810648bc14cd3b",
    },
    "No shift logs yet": {
      hash: "8ce311a77e2d0755",
    },
    "No shifts added yet": {
      hash: "17303837a7538dd9",
    },
    "No shifts on this day": {
      hash: "96b562d99d00fdab",
    },
    "No shifts scheduled": {
      hash: "0e113a777f41b3a5",
    },
    "No shifts staged yet": {
      hash: "675781c7c0e04437",
    },
    "No show detected, replaced": {
      hash: "4375644cd8a073a8",
    },
    "No show, replacing...": {
      hash: "a0cdf03cc74c5033",
    },
    "No {{timeSlot}} shifts were posted": {
      hash: "cb86a681fcfaf0da",
    },
    "No, I don't want the professional to be penalized": {
      hash: "51bb47c0de265566",
    },
    "Not now": {
      hash: "a0e63d7c7125d29a",
    },
    "Note: Roster workers do not have rates and will not see or receive rate changes.": {
      hash: "82fc2d12a96f469a",
    },
    "Notes for professionals": {
      hash: "7038572cdeb56103",
    },
    Notice: {
      hash: "65659145569b894b",
    },
    "One professional books an entire block": {
      hash: "9cd196d90bf55de2",
    },
    Only: {
      hash: "879d8fb64f88733e",
    },
    "Only post a shift in Clipboard when you are absolutely certain — this will likely break the shift's synchronization with the Staff Lion system.":
      {
        hash: "a60c0027df397eed",
      },
    "Only professionals of your selected gender will be able to view new shifts you post. This will not affect shifts you've already posted.":
      {
        hash: "fbed4f5f88700625",
      },
    "Open daily view for {{dateLabel}}": {
      hash: "3095ee946570a186",
    },
    "Open {{dateLabel}} shifts": {
      hash: "fd11f315e1f2cf34",
    },
    Optional: {
      hash: "59be71333c960fd0",
    },
    "Optional — tell the professional anything they should know.": {
      hash: "cdcf0c647f9af9c6",
    },
    "Or select a calendar slot to add a shift": {
      hash: "1aa7434e840e2e6f",
    },
    "Other Professionals": {
      hash: "95f7a41f508314ad",
    },
    "Our location data shows that this professional is still in the building.": {
      hash: "06f89d205e418697",
    },
    "Part of a shift block": {
      hash: "71c6639e24d817f0",
    },
    "Part of a {{shiftCount}}-shift block": {
      hash: "28fa073686270307",
    },
    "Payment due": {
      hash: "a648708bed4aa733",
    },
    "Pending rate proposals": {
      hash: "8d8c27652b244dfe",
    },
    "Pending requests to book": {
      hash: "8b045ff0baac5c19",
    },
    Phone: {
      hash: "63dceb8800b2dd4a",
    },
    "Please confirm that this professional was a No Show.": {
      hash: "0427ec78ba6e5aa9",
    },
    "Please describe the issue so we can take appropriate action.": {
      hash: "e49583f95ccf5db7",
    },
    "Please describe what happened.": {
      hash: "08fdcac2f5d9611f",
    },
    "Please ensure your contract details are up-to-date by {{deadline}}. If you have any questions, please reach out to":
      {
        hash: "ed77e681ad80e655",
      },
    "Please review and sign your": {
      hash: "255381b98af5d088",
    },
    "Please select a different time slot to send invites.": {
      hash: "fa1c346ae61602cd",
    },
    "Please select an option": {
      hash: "09b864507d1e8cf0",
    },
    "Please select another professional to invite.": {
      hash: "6b90bc9c4208233d",
    },
    "Please select at least one reason": {
      hash: "3499752d53797ff5",
    },
    Post: {
      hash: "a5554622c655c7a7",
    },
    "Post a new {{qualificationDisplayName}} shift": {
      hash: "24331847f1d79bdf",
    },
    "Post a new {{timeSlot}} shift": {
      hash: "7ed1f0d4b2b0faeb",
    },
    "Post as open shift": {
      hash: "1bf3bb986c8f9da0",
    },
    "Post block": {
      hash: "0148bffc150339a2",
    },
    "Post shift with rush fee": {
      hash: "837e8d24e44d8288",
    },
    "Post shifts": {
      hash: "d3159e27a9330927",
    },
    "Post shifts with rush fee": {
      hash: "7e95d39fd43fb729",
    },
    "Post {{additionTotal}} & Remove {{removalTotal}}": {
      hash: "36b67fc35f565beb",
    },
    "Post {{additionTotal}} shifts": {
      hash: "bfb925ed2f8e4326",
    },
    "Preparing removals...": {
      hash: "02aa21b190be93e3",
    },
    "Previous date": {
      hash: "df2d0dc8e24c0ff3",
    },
    "Previous month": {
      hash: "6a2769502a5dda78",
    },
    Print: {
      hash: "df0fe79898ef413e",
    },
    "Priority window unit": {
      hash: "3a38aa141f8de7b9",
    },
    "Professional in the building": {
      hash: "fbab7e0010099396",
    },
    "Professional type": {
      hash: "3617bd6b5a419818",
    },
    "Professional types info": {
      hash: "127c043502a4a52d",
    },
    "Professionals can book without this document": {
      hash: "6ba7ed94943d0b33",
    },
    "Professionals of any gender will be able to view new shifts you post. This will not affect shifts you've already posted.":
      {
        hash: "83221ab96f11b0cf",
      },
    Profile: {
      hash: "d696a35bdd1883da",
    },
    Propose: {
      hash: "1cbd9e713d937bad",
    },
    "Propose a new shift time": {
      hash: "7e271cc38a9f2950",
    },
    "Provide additional information about your workplace to get higher chances to fill your shifts.":
      {
        hash: "43e2e6af44325a1b",
      },
    Qualifications: {
      hash: "7b4339cf860e01a6",
    },
    "Rate Proposals ({{proposalCount}})": {
      hash: "8850a960f4e7675d",
    },
    "Rate proposal sent successfully": {
      hash: "86a3835bd36c3318",
    },
    "Rather discuss your required documents?": {
      hash: "7450add02db5e174",
    },
    "Re-enable this qualification in your workplace settings, or choose a different qualification for this shift.":
      {
        hash: "dcbf6f252e4b9118",
      },
    "Reason for removal": {
      hash: "15f9bd7ac18aacd0",
    },
    "Recent Professionals": {
      hash: "2e811ac7cc6b5daa",
    },
    Refresh: {
      hash: "0e91610117029a62",
    },
    "Remove Roster shift": {
      hash: "70e88997202f3fe7",
    },
    "Remove Shift": {
      hash: "e1eeb204d8795e72",
    },
    "Remove block": {
      hash: "50789882cb44cfc0",
    },
    "Remove block?": {
      hash: "b48fd06fbc1b8006",
    },
    "Remove from Do Not Return list": {
      hash: "f37da14136c22f95",
    },
    "Remove from Do Not Return list?": {
      hash: "f0db9bf158906717",
    },
    "Remove one {{slotLabel}} shift on {{dateLabel}}": {
      hash: "7af129ac87e6c3fb",
    },
    "Remove shift": {
      hash: "407fd659c6c7c9c7",
    },
    "Remove unfilled shift": {
      hash: "4f07b5f2af1022e1",
    },
    "Remove {{removalTotal}} shifts": {
      hash: "010926c3ad6a439e",
    },
    "Remove {{slotLabel}} shift": {
      hash: "a0dcca719b0b6692",
    },
    "Remove {{slotLabel}} shift from block": {
      hash: "9ec09d9fdf3dd405",
    },
    "Remove {{slotLabel}} shift on {{dateLabel}} from block": {
      hash: "bd59825da9bf173a",
    },
    "Removing shifts... ({{removed}}/{{totalToRemove}})": {
      hash: "3e5616600c45579f",
    },
    "Replacing...": {
      hash: "8a9de5c92e68f67c",
    },
    "Report an Issue": {
      hash: "f6a30a10bc27be0a",
    },
    "Reports of poor attendance or unprofessional conduct.": {
      hash: "01d786e808b3bcce",
    },
    "Require approval to book": {
      hash: "a2e7e693ab5bc9c0",
    },
    "Require gender-specific {{serviceTerm}}": {
      hash: "cdebca45b801e8b2",
    },
    Required: {
      hash: "4850b174b713d88c",
    },
    "Reset to default": {
      hash: "bc5b45ae7b60692a",
    },
    Retry: {
      hash: "942087cc2d41e013",
    },
    "Review and sign our contract so that you can start posting shifts.": {
      hash: "260eae735d6581d7",
    },
    "Review changes": {
      hash: "6a47708f4e14c122",
    },
    "Review invite": {
      hash: "e0c7fc6777c19333",
    },
    "Review requirements": {
      hash: "558904acdc18ee4e",
    },
    "Review the queued changes before applying them.": {
      hash: "dd999b9a72aa9249",
    },
    "Roster shift removed": {
      hash: "04c8566c6fa2ffdb",
    },
    "Roster shift: no cancellation fee": {
      hash: "2b90bd98983c5a81",
    },
    "Round {{roundCount}}": {
      hash: "090b6e496147b1a4",
    },
    "Rush fee": {
      hash: "7d1e234cd60235a4",
    },
    "Rush fee applies": {
      hash: "74a58af4a2da23e0",
    },
    Sa: {
      hash: "a951efc79deb7ff3",
    },
    "Same as their offer — did you mean to accept?": {
      hash: "07555299c4f812c8",
    },
    Sat: {
      hash: "fdeb71b569e0034d",
    },
    Save: {
      hash: "1509f561f2416598",
    },
    "Save times": {
      hash: "df615262aa1a1669",
    },
    Saved: {
      hash: "b5c120b316c237a0",
    },
    "Saving ": {
      hash: "8d3085ef72407e54",
    },
    "Search for a professional to invite.": {
      hash: "44936a2ec05fa2f5",
    },
    "Search professionals...": {
      hash: "19dcad6dea244c2e",
    },
    "See less": {
      hash: "d1cee48d0de28c45",
    },
    "See more": {
      hash: "bab37d62472990c0",
    },
    "Select another professional": {
      hash: "75c298c733082225",
    },
    "Select qualification": {
      hash: "a87abb24997dcec6",
    },
    "Select shift dates for your block": {
      hash: "1de82c89364987c9",
    },
    "Select shift type": {
      hash: "745fc5be2efa1531",
    },
    "Select the reasons for DNR:": {
      hash: "76319028bb672ced",
    },
    "Select {{date}}": {
      hash: "ea2cc40d45cd99cf",
    },
    "Select {{date}}, today": {
      hash: "9a7b8a4e1d434df4",
    },
    "Selected Professional": {
      hash: "edd32138d380825b",
    },
    Send: {
      hash: "f6f4688ff23d50c6",
    },
    "Send Invite": {
      hash: "c1ad5dcf2e0576ad",
    },
    "Send Invite instead": {
      hash: "0056ce5e7561ee81",
    },
    "Send invite": {
      hash: "76a13f805cdc1b8b",
    },
    "Send invite with rush fee": {
      hash: "cdbdac1da505071e",
    },
    "Send invites": {
      hash: "c57456e4427dcf0b",
    },
    "Sent home at {{time}}": {
      hash: "f491d58207eb7fcb",
    },
    "Set this as my default": {
      hash: "bfd5b1e3bd191611",
    },
    Shift: {
      hash: "2e544a292f6979ed",
    },
    "Shift Block": {
      hash: "6269e24f31555003",
    },
    "Shift ID": {
      hash: "ee0f0495791d4693",
    },
    "Shift Log": {
      hash: "3fb9316bd977b9ff",
    },
    "Shift Types": {
      hash: "fbbf67422e5e3648",
    },
    "Shift cancelled": {
      hash: "a55e892ad25cbf89",
    },
    "Shift couldn't be deleted": {
      hash: "d87fdadabf8915bc",
    },
    "Shift removed": {
      hash: "0b9447ec7bc5d691",
    },
    "Shift time could not be updated. Please try a different time or contact support.": {
      hash: "52828dd3cf9a3a8a",
    },
    "Shift time proposal sent": {
      hash: "f286dc334b128966",
    },
    "Shift times updated": {
      hash: "4161e0b718d06dfc",
    },
    "Shift will open to Clipboard at {{time}} on {{date}}": {
      hash: "4c4ea06708bbe3bb",
    },
    "Shifts in block": {
      hash: "5bbd271ed5b84a80",
    },
    "Shifts in this block": {
      hash: "eb365f0fe1e6acbb",
    },
    "Shifts posted but quiz update failed": {
      hash: "d91ef4ac7730f4e3",
    },
    "Show all shift types": {
      hash: "ec6ef45d6169b644",
    },
    "Show charge rate": {
      hash: "3978a81d56856530",
    },
    "Show fewer shift types": {
      hash: "95836f82062da8db",
    },
    "Show more shift types": {
      hash: "7e16ac00450dfbef",
    },
    "Show only {{label}}": {
      hash: "31eaff37b666d873",
    },
    "Show sidebar": {
      hash: "9e8197ce9e5f9592",
    },
    "Signed by ": {
      hash: "fdfd43ff69947f68",
    },
    "Slot type": {
      hash: "2f3a0951c5962882",
    },
    "Smart Pricing": {
      hash: "2f51b30db4cd1176",
    },
    "Smart Pricing info": {
      hash: "c5f0e3e0ade58c8e",
    },
    "Some queued shifts are in the past.": {
      hash: "24b7bdf3f774ecd8",
    },
    "Some shifts start soon": {
      hash: "c2ff8acd4ad3c7b4",
    },
    "Someone from the Clipboard team will reach out within 1 business day to review your workplace's document requirements with you.":
      {
        hash: "cff929e95dd0ab8f",
      },
    "Something went wrong. Please try again.": {
      hash: "3ccd9d6586ef9143",
    },
    "Starred Professionals": {
      hash: "79a9d7d5e52b144a",
    },
    "Start date": {
      hash: "8169693101a4536c",
    },
    "Start over": {
      hash: "5eed7e9fc8f3cd68",
    },
    "Start time": {
      hash: "babe9dda85036fe4",
    },
    Su: {
      hash: "2d88a3a2842eb3c9",
    },
    "Submit payment": {
      hash: "076957bce71fa868",
    },
    "Successfully accepted the negotiation and assigned the shift to {{workerName}}": {
      hash: "e495b3551c367816",
    },
    "Successfully ended the negotiation with {{workerName}}": {
      hash: "017c1e356e1333d8",
    },
    Sun: {
      hash: "db18f17fe5320076",
    },
    "Talk to someone from our team.": {
      hash: "a9e590a172099aac",
    },
    "Tap + to post a shift": {
      hash: "cc93c1c99d40314f",
    },
    "Terms of Service": {
      hash: "4afa55bf7aec7ddc",
    },
    Th: {
      hash: "3bff939c10f4d9bc",
    },
    "The Missed Punch Request feature is live for this workplace. Please follow the MPR SOP for any shift verification or adjustment requests.":
      {
        hash: "def235b01a680a58",
      },
    "The block has been created successfully": {
      hash: "b96d5ff6260b4c81",
    },
    "The professional has been added to the Do-Not-Return list.": {
      hash: "fb75f6d7a6206272",
    },
    "The professional is leaving without my permission.": {
      hash: "84b00ba36056eea9",
    },
    "The professional left with my permission.": {
      hash: "fc8a478384f2d805",
    },
    "The shift start time of": {
      hash: "4f942ae1ac336f51",
    },
    "The shift will only be visible to the invited professional. If they don't accept, the shift won't be posted and you'll need to manually post it or invite someone else.":
      {
        hash: "ec53b715f5a4b205",
      },
    "The shift will remain available for other qualified professionals to pick up until it is filled or expires.":
      {
        hash: "9cbf17bb0535e1ff",
      },
    "Their Latest Offer": {
      hash: "6f21f336aa5f9f6a",
    },
    "There is an unbooked shift ({{qualification}}, {{unbookedTimeRange}}) in the same slot as {{workerFirstName}} ({{qualification}}, {{bookedTimeRange}}).":
      {
        hash: "25a30cd36d986509",
      },
    "There is an unbooked shift in the same slot. What would you like to do?": {
      hash: "1071668ed0a4e232",
    },
    "These documents are blocking nearby professionals who may be interested in your shifts.": {
      hash: "3ec90c0349b2f97b",
    },
    "These documents may be blocking nearby professionals from booking your shifts.": {
      hash: "3ce2791bc098fe1f",
    },
    "These times apply to every shift staged for this {{slotLabel}} slot on {{dayLabel}}. Other days use the workplace default.":
      {
        hash: "9ec49dbdc7bdcabf",
      },
    "These times become the default for {{qualification}} in month bulk posting and the daily posting surface.":
      {
        hash: "2d1f9e0d071255c9",
      },
    "They can still book at the posted rate. Other negotiations for this shift stay open.": {
      hash: "b0641e791fa87d39",
    },
    "This books the shift at {{payRate}}/hr pay and {{chargeRate}}/hr charge. Other open negotiations will transfer to available shifts.":
      {
        hash: "0bfdbd4c5ea7d528",
      },
    "This is above their offer": {
      hash: "2c9ae8e4cf7e2d3d",
    },
    "This option is checked by default to maximize your chances of filling the shift.": {
      hash: "2ca0beb5c205fd55",
    },
    "This page has been updated while you were away. Refresh to get the latest.": {
      hash: "fcea6d759b6c1834",
    },
    "This professional cannot receive this invite.": {
      hash: "929bbe292fcd5071",
    },
    "This professional has been blocked by your workplace and cannot be invited.": {
      hash: "fca60b3c431a22a8",
    },
    "This shift cannot be posted because its start time has already passed.": {
      hash: "27f4beaf2d0c3765",
    },
    "This shift has not been posted or invited yet. Discard this draft?": {
      hash: "b06fff5032205ff2",
    },
    "This shift starts soon": {
      hash: "98b907a974c7e66f",
    },
    "This shift starts soon at": {
      hash: "7fc5eb1dfd5320ef",
    },
    "This shift time proposal may result in the professional having more than 16.5 consecutive hours of shifts booked. Are you sure you want to propose this shift time?":
      {
        hash: "aab34f0b19ac7c0a",
      },
    "This shift was canceled": {
      hash: "19faf265a62c6297",
    },
    "This shift was canceled ($)": {
      hash: "6dc6e21727fb5327",
    },
    "This shift will be cancelled.": {
      hash: "f405af18c7f9b71e",
    },
    "This shift will be opened to Clipboard professionals on": {
      hash: "b98884ab0a39304e",
    },
    "This will cancel both the shift and {{workerFirstName}}.": {
      hash: "324a91e31f9f93d7",
    },
    "This will un-assign them but keep the shift open for other professionals to book.": {
      hash: "63902b91749dd1cd",
    },
    "This worker will be able to book shifts at your facility again.": {
      hash: "e7f5f530c6b8b2af",
    },
    Thu: {
      hash: "7da11212ed340ea7",
    },
    "Time and license editing is disabled for Roster shifts.": {
      hash: "edc48b5a5ae34fe6",
    },
    "Time slot unavailable": {
      hash: "624c1c4ae0e337d5",
    },
    Timesheet: {
      hash: "6d320a315fe443f9",
    },
    Today: {
      hash: "2b065c7c9ce466e5",
    },
    "Toggle any requirement to optional and we'll update your workplace's document requirements.": {
      hash: "5c78570dfc24ed1f",
    },
    "Total new shifts:": {
      hash: "4774eebd95c6b9a8",
    },
    "Total shifts: {{shiftCount}}": {
      hash: "ee36016ce41c648c",
    },
    Tu: {
      hash: "62afcc74654de6ab",
    },
    Tue: {
      hash: "d1eb39b09bf52b68",
    },
    "Type a message": {
      hash: "00cd58f655daed8a",
    },
    "Unable to accept the negotiation. Please try again.": {
      hash: "701c76afce2dc9f5",
    },
    "Unable to enable {{typesList}}. Please contact Clipboard Health support to configure charge rates for your workplace.":
      {
        hash: "e0e5e52c71ebbe8d",
      },
    "Unable to end the negotiation. Please try again.": {
      hash: "9cf43b59441404fb",
    },
    "Unable to load monthly counts.": {
      hash: "ceebd437e1769f44",
    },
    "Unable to load shift details": {
      hash: "abb3f3a4080a44fb",
    },
    "Unable to load shift logs": {
      hash: "74cde7a4ea38225f",
    },
    "Unable to load slot details.": {
      hash: "a597b36badcfaf6a",
    },
    "Unable to propose this shift time": {
      hash: "56f15e2c34e48b3b",
    },
    "Unable to send invite": {
      hash: "22ae3ae1b8f20bc7",
    },
    "Unable to update this shift time": {
      hash: "763d720d368de2e9",
    },
    Unblock: {
      hash: "712da63171e0c9de",
    },
    Unfilled: {
      hash: "ca4153b6bb219647",
    },
    Unknown: {
      hash: "b764cdc0eab71374",
    },
    "Unknown Worker": {
      hash: "c1ef7fe3e0d8054c",
    },
    "Update charge rate for all {{shiftCount}} unfilled {{qualificationName}} shifts from {{startTime}} - {{endTime}}":
      {
        hash: "d62c7b74e509674f",
      },
    Urgent: {
      hash: "1b015904cc17649e",
    },
    "Use the + button on a calendar slot to add shifts. They'll show up here grouped by day.": {
      hash: "8fbb370cbd171142",
    },
    "Variable Charge disabled": {
      hash: "1adcf08dfb9aae9e",
    },
    "Variable Charge enabled": {
      hash: "f667a06d7d7ff1b8",
    },
    "Variable Charge feature disabled.": {
      hash: "19aafeafb4adfec9",
    },
    "Variable Charge feature enabled. You can now edit rates on shift cards.": {
      hash: "b52874990d85754c",
    },
    "View candidates": {
      hash: "1060c7e27852f3f2",
    },
    "View contract": {
      hash: "964b67c944a13ef9",
    },
    "View profile": {
      hash: "d4788f256f730423",
    },
    "View timesheet": {
      hash: "472c6c914210d3d9",
    },
    "View {{shiftCount}}-shift block details": {
      hash: "aa3e775302e19635",
    },
    "Visible on calendar": {
      hash: "e7f458685df1a5c3",
    },
    "Waiting for response": {
      hash: "12129eebb9eb8b03",
    },
    Warning: {
      hash: "e981ddae45d8f4ca",
    },
    We: {
      hash: "f3fe997b8d1ce818",
    },
    "We want to help you maintain coverage during {{eventName}}. Ask an admin or corporate decision maker to enable Variable Charge for your workplace.":
      {
        hash: "ea62f7ad88138eed",
      },
    "We won't charge you more than the rate you input.": {
      hash: "1e6f33ef90a1b9e4",
    },
    "We'll find a replacement professional": {
      hash: "ccaaff90680a3fbe",
    },
    "We'll post an urgent shift and start looking for a replacement professional. No extra charge.":
      {
        hash: "b9f4177e92b021c2",
      },
    "We'll use our best in class pricing algorithms to find you a professional at the lowest rate possible.":
      {
        hash: "7e05c585ff758063",
      },
    "We've identified a change of ownership for this facility and a new contract is required to continue using our platform. You're unable to book new shifts until the updated contract is in place.":
      {
        hash: "e4b6399c711b5c9b",
      },
    Wed: {
      hash: "58339f45df960408",
    },
    "When checked:": {
      hash: "f60420bece08cd42",
    },
    "When unchecked:": {
      hash: "5db5ce1b1688c4bc",
    },
    "Winter Storm Coverage": {
      hash: "204c32396d64a8af",
    },
    Woman: {
      hash: "5c3967e73c04beef",
    },
    "Women only": {
      hash: "36ac4b709817ee04",
    },
    "Work history": {
      hash: "cfb80983bacc8ce9",
    },
    "Worked {{shiftCount}} shift": {
      hash: "79415acaf556f49e",
    },
    "Worked {{shiftCount}} shifts": {
      hash: "5435c98f684b34df",
    },
    Worker: {
      hash: "a67b04cd5c491d4d",
    },
    "Worker ID": {
      hash: "069d7e9d898e4d81",
    },
    "Worker asked me to cancel": {
      hash: "dc1011d87ddbaa17",
    },
    "Workplace ID": {
      hash: "049245ad1f768a37",
    },
    "Yes, I want the professional to be penalized": {
      hash: "d7022e3f612fdabf",
    },
    You: {
      hash: "08b041935798fbf6",
    },
    "You are about to post {{additionTotal}} and remove {{removalTotal}} {{qualificationLabel}} shifts.":
      {
        hash: "9872a19ccc59e398",
      },
    "You are about to post {{additionTotal}} {{qualificationLabel}} shifts.": {
      hash: "2e218ce6e44faf2c",
    },
    "You are about to remove {{removalTotal}} {{qualificationLabel}} shifts.": {
      hash: "74fd12fee729a47d",
    },
    "You are seeing this banner because key details in your contract need to be verified. To avoid interruption, please discuss this with our team by {{deadline}}.":
      {
        hash: "3524eba34999f164",
      },
    "You can only create a maximum of {{maximumShiftCount}} shifts at a time.": {
      hash: "b1b5289afe723700",
    },
    "You have": {
      hash: "af3f12e161fdb1cb",
    },
    "You have past due invoices. If you do not submit a payment by {{pendingDate}}, your account will be blocked from filling any further shifts. Any shifts that are already filled will not be affected.":
      {
        hash: "a411cdc69171bcef",
      },
    "You have unposted shifts": {
      hash: "df2c3b3e38746905",
    },
    "You proposed {{payRate}}/hr": {
      hash: "974af971aadee8b9",
    },
    "You've reached your weekly approved cap and are not able to post any further shifts. Please reach out to your account manager, billing representative, or billing@clipboardhealth.com for assistance.":
      {
        hash: "4796d436b7eec305",
      },
    "Your Latest Offer": {
      hash: "5531037d5744cee1",
    },
    "Your account is Pending due to past due invoices. Pending accounts cannot fill any further shifts, but shifts that are already filled will not be affected.":
      {
        hash: "2a817149e3aeea86",
      },
    "Your account is currently pending": {
      hash: "5ae266fd755ca628",
    },
    "Your account is inactive": {
      hash: "d900a0ee4fa75a07",
    },
    "Your account is inactive. Please reach out to Clipboard Health Support": {
      hash: "f67a23ce7574418d",
    },
    "Your account is pending": {
      hash: "38a99ec1b1d35732",
    },
    "Your account is suspended": {
      hash: "355a68d4614fc7f9",
    },
    "Your account is suspended for missing payments": {
      hash: "e51258e58c381769",
    },
    "Your account will be placed on hold due to missed payments": {
      hash: "92f5e0bdde0f12fb",
    },
    "Your response is anonymous and for Clipboard's internal use only.": {
      hash: "ef3d67c37d8e0333",
    },
    "Your shift was not added": {
      hash: "67132f11ff8ff152",
    },
    "Your usage cap has been reached": {
      hash: "bba4c17d03c1f365",
    },
    "Your workplace will be charged {{feeDisplay}} for this professional's time.": {
      hash: "f53a2330667daa5f",
    },
    "Your workplace won't be charged a cancellation fee for cancelling this Roster shift.": {
      hash: "ebd61f0962a28e4f",
    },
    "Your workplace won't be charged a cancellation fee for cancelling this shift.": {
      hash: "94cf88d91055c26a",
    },
    "a fee": {
      hash: "77a562b657da74bf",
    },
    "accept booking request": {
      hash: "751c15306765d550",
    },
    agreement: {
      hash: "46a81739c6ee7c1d",
    },
    "before the shift starts.": {
      hash: "e8a4d4ad48f48070",
    },
    "breakPolicies requiresLunchBreak": {
      hash: "938220cf22b2c66e",
    },
    "contact support online": {
      hash: "8795fb4cfe8a7f38",
    },
    "for assistance.": {
      hash: "23bbca4c71300543",
    },
    "for cancelling this filled shift less than": {
      hash: "1dbe776f8df153b6",
    },
    "from a previous session. Continue where you left off, or start over by posting": {
      hash: "414fdb23cbd5f38e",
    },
    "has already passed. How long should professionals be able to book this shift?": {
      hash: "006f457d56bae1c7",
    },
    here: {
      hash: "fcec91509759ad99",
    },
    off: {
      hash: "b4dc66dde806261b",
    },
    on: {
      hash: "b8d31e852725afb1",
    },
    or: {
      hash: "7175517a370b5cd2",
    },
    "so we can assist.": {
      hash: "da1f3c19871c3a58",
    },
    "the upcoming winter storm": {
      hash: "5e40f803e47d6624",
    },
    "the winter storm": {
      hash: "1ef1ab0d0f5450eb",
    },
    "the worker": {
      hash: "19aa8a3468d17bc7",
    },
    "these {{count}} shifts": {
      hash: "b59c75232481974b",
    },
    "this shift": {
      hash: "b0a7b3c03119094c",
    },
    "this worker type": {
      hash: "3f84c2bf421a83d0",
    },
    "to be penalized?": {
      hash: "eaa0049d20863b68",
    },
    "to re-enroll your account. Pending status means you are not able to accept further shifts, but any shifts that are already filled will not be affected. If you're not authorized to sign this agreement, please forward this link to the relevant person at your organization. For any questions, please contact":
      {
        hash: "b2eb2fd9a90f488b",
      },
    "view worker documents": {
      hash: "9841ea515c1c0ae1",
    },
    "{{count}} Shift": {
      hash: "968e3c7a50310a66",
    },
    "{{count}} Shifts": {
      hash: "8e36307961c6d5c1",
    },
    "{{count}} available professional": {
      hash: "1c88343383eec30e",
    },
    "{{count}} available professionals": {
      hash: "600dc26d055ac98a",
    },
    "{{count}} candidates are awaiting your review. Please review them now and choose to request an interview or decline.":
      {
        hash: "c6e9bec0b2a092db",
      },
    "{{count}} date selected": {
      hash: "8dd52892f76fe969",
    },
    "{{count}} dates selected": {
      hash: "e7ecdf0d31e14d57",
    },
    "{{count}} shift": {
      hash: "a93acb02cbaea116",
    },
    "{{count}} shifts": {
      hash: "cd72097a6f69799d",
    },
    "{{failed}} shift could not be removed": {
      hash: "1367a2d916565114",
    },
    "{{failed}} shifts could not be removed": {
      hash: "1e7a2f6e8859d410",
    },
    "{{feeAmount}} fee": {
      hash: "172f70e865600bcb",
    },
    "{{filledShiftsCount}} of {{totalShifts}} filled": {
      hash: "b82274d4b5cf3655",
    },
    "{{hours}} hour": {
      hash: "7c94eda094c800ff",
    },
    "{{hours}} hours": {
      hash: "3ca15ca441e1a3db",
    },
    "{{postedShiftCount}} of {{totalPendingShifts}} posted": {
      hash: "bc17b7d2c6a26cbf",
    },
    "{{qualificationLabel}} shifts?": {
      hash: "6cca5d22536aef55",
    },
    "{{qualification}} shift": {
      hash: "7ddacf9693938efc",
    },
    "{{rateDifference}} above posted rate": {
      hash: "2d74b9c80eb0770e",
    },
    "{{removed}} shift removed": {
      hash: "c1a2763f82ebe0b9",
    },
    "{{removed}} shifts removed": {
      hash: "627bfc3844c6d390",
    },
    "{{shiftCount}} future shift booked": {
      hash: "10252e02c5f434c1",
    },
    "{{shiftCount}} future shifts booked": {
      hash: "be1e4a39db83f8cc",
    },
    "{{shiftCount}} shift": {
      hash: "fc00ac0a095eedbf",
    },
    "{{shiftCount}} shifts": {
      hash: "7cb1dcb673d3dcc9",
    },
    "{{slotLabel}} end time": {
      hash: "ff7ebe47a75b69b6",
    },
    "{{slotLabel}} shifts, empty": {
      hash: "65b05e85db8eb9ce",
    },
    "{{slotLabel}} shifts, {{filledCount}} filled out of {{totalCount}}": {
      hash: "fdc923f7b593d952",
    },
    "{{slotLabel}} shifts, {{filledCount}} filled out of {{totalCount}}, time slot has passed": {
      hash: "2dc9bc64d8899540",
    },
    "{{slotLabel}} start time": {
      hash: "b50e079820bbe89d",
    },
    "{{totalCharge}}/hr total": {
      hash: "2d88b01c3fb29b61",
    },
    "{{workerName}} has been added to the Do Not Return list": {
      hash: "46586575deed6e93",
    },
    "{{workerName}} has been removed from the Do Not Return list": {
      hash: "d1aa2cfcd4669bc8",
    },
  },
  settings: {
    About: {
      hash: "4efca0d10c5feb8e",
    },
    "Add Extended Break Rule": {
      hash: "bf8d19636791d7d7",
    },
    "Add any additional breaks for longer shift lengths here. When selected, workers will be required to take the set break length for the shift length defined below.":
      {
        hash: "c88a1f4319eaaf8d",
      },
    "Allow professionals to propose rates on shifts": {
      hash: "a0be4aaec8295265",
    },
    "Any qualification": {
      hash: "da50017b4af59e26",
    },
    "App version and update information.": {
      hash: "ec6dd417ce5e7977",
    },
    "At least one professional type must be visible.": {
      hash: "0293bf6baa4da730",
    },
    "Auto-approve settings updated successfully": {
      hash: "2867be8d7523b61f",
    },
    "Auto-decline break requests disabled successfully.": {
      hash: "87f82bcdf0731618",
    },
    "Auto-decline break requests enabled successfully.": {
      hash: "fcbd1eaf717dc48b",
    },
    "Auto-verify shifts after clock-out (Grace Period)": {
      hash: "31ca56a9136579db",
    },
    "Auto-verify threshold in minutes": {
      hash: "c02747ac5f5c7273",
    },
    "Automatically decline expiring break payment requests": {
      hash: "aaefaa4c202b693c",
    },
    "Badge requirement updated successfully": {
      hash: "dce23e196411bb19",
    },
    "Block professionals from booking excessive consecutive hours": {
      hash: "aba5efd1a814f972",
    },
    "Block professionals from booking excessive weekly hours": {
      hash: "10028063dd2dfd0d",
    },
    "Break length in minutes": {
      hash: "9d481643628c5d4e",
    },
    Build: {
      hash: "bdd254b65baac169",
    },
    "Calendar Display": {
      hash: "a9b847b2689edc15",
    },
    "Calendar settings saved successfully": {
      hash: "fa9f08cef921d924",
    },
    "Call instructions": {
      hash: "a307781c6d410504",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    Charting: {
      hash: "f4d573798f5b25fe",
    },
    "Charting Compliance": {
      hash: "6c5b2cad2f85979d",
    },
    "Charting Compliance Grace Period": {
      hash: "4ea6b01896b99aaa",
    },
    "Charting compliance updated successfully": {
      hash: "67fe49da5dc9c9df",
    },
    "Choose your preferred language for the redesigned pages.": {
      hash: "7b1adb15b1899b5e",
    },
    "Compliance & Documentation": {
      hash: "f46c7130506f2478",
    },
    "Configure clock-in restrictions, break policies, and attendance verification.": {
      hash: "362a5555c74569b3",
    },
    "Configure worker credentials for charting and timekeeping, and configure the onboarding view.":
      {
        hash: "de6f98ae0bbb9c6e",
      },
    "Configure worker type visibility and ordering on the calendar.": {
      hash: "c0aa98240e66b4c9",
    },
    "Control rate negotiation and billing integrations.": {
      hash: "29e2cad39d7468e7",
    },
    "Declination reason": {
      hash: "b1cfc10aede4c39f",
    },
    "Declination reason updated successfully.": {
      hash: "257da42c62c99413",
    },
    Disable: {
      hash: "b7e3e4aa4257b9a1",
    },
    "Disable Maple integration?": {
      hash: "774e9813ce70b676",
    },
    "Disabling the Maple integration will stop all shift syncing with Maple for this workplace. This may cause the integration to become out of sync.":
      {
        hash: "3251e2ac1ea2509c",
      },
    Edit: {
      hash: "464c4ffd019e1e96",
    },
    "Edit Start of Shift Orientation": {
      hash: "7e8e9084e6c5087a",
    },
    "Edit call instructions": {
      hash: "9bf39a1c52cfe90e",
    },
    "Edit declination reason": {
      hash: "9578186350a9aa2d",
    },
    "Edit paid rest period policy": {
      hash: "a06e6300e86256b9",
    },
    "Edit policy": {
      hash: "18f41a84465f6462",
    },
    Enable: {
      hash: "5342e09f2729fbc6",
    },
    "Enable Instant Book for past workers": {
      hash: "a752a5ec88bbf67d",
    },
    "Enable Instant Book for previously approved professionals": {
      hash: "9c44b4cfe4f02691",
    },
    "Enable Maple integration?": {
      hash: "2f6ffdd61800cc85",
    },
    "Enable QR code sign out": {
      hash: "2de9bd54d2237316",
    },
    "Enable Request to Book": {
      hash: "851c9851d07cd16f",
    },
    "Enable auto-verify shifts after clock-out": {
      hash: "3770d69cbbc0b4b1",
    },
    "Enabling the Maple integration will sync shifts with Maple for this workplace.": {
      hash: "245e2e6200d75f82",
    },
    English: {
      hash: "ba118bf7fc9c1aed",
    },
    "Enter a default declination reason to use at the end of the review window": {
      hash: "ed7d194dfdf2d7d2",
    },
    "Enter device ID": {
      hash: "5a73db704d5aba8e",
    },
    "Enter {{fieldName}}...": {
      hash: "12f3883c328acb33",
    },
    "Error saving calendar settings. Please try again later.": {
      hash: "a6f7b34c25b558f1",
    },
    "Error updating HostedTime device ID. Please try again later.": {
      hash: "55415f12f011587e",
    },
    "Error updating Maple integration. Please try again later.": {
      hash: "070a37fdf99a9b4b",
    },
    "Error updating QR code sign out. Please try again later.": {
      hash: "e5c1a2c44b487954",
    },
    "Error updating badge requirement. Please try again later.": {
      hash: "1327eba28e201aa6",
    },
    "Error updating charting compliance. Please try again later.": {
      hash: "4782a946cda86e5b",
    },
    "Error updating facility profile": {
      hash: "4e11fb106fc1beaf",
    },
    "Error updating grace period. Please try again later.": {
      hash: "3cb794619991fb44",
    },
    "Error updating rate negotiation setting. Please try again later.": {
      hash: "b9d5e7d60c6b2145",
    },
    "Error updating worker credential configuration. Please try again later.": {
      hash: "6f394b954182ea8e",
    },
    "Error updating workplace's profile. Please try again later.": {
      hash: "84cbe21ac1b40897",
    },
    "Failed to delete NFC tag.": {
      hash: "7c95a22d84b8d584",
    },
    "Failed to request NFC tags.": {
      hash: "12c831575018380f",
    },
    "Failed to update NFC tag location.": {
      hash: "2a3c8aeaa199cf52",
    },
    "Failed to update Start of Shift Orientation.": {
      hash: "141faceb777ac6c0",
    },
    "Failed to update auto-decline setting.": {
      hash: "16216d9aaa98d192",
    },
    "Failed to update declination reason.": {
      hash: "759000dbc800b55f",
    },
    "Failed to update late-cancellation call notification.": {
      hash: "da53b30af3fef836",
    },
    "Failed to update mandatory break policy.": {
      hash: "c5b6f7fc03f24904",
    },
    "Failed to update mandatory break rules.": {
      hash: "766e59dd3e549867",
    },
    "Failed to update mandatory break setting.": {
      hash: "8df23bc99cbf8662",
    },
    "Failed to update rest break policy.": {
      hash: "adbcd39b8810299a",
    },
    "Failed to update rest break setting.": {
      hash: "9fb7286cb8e833d0",
    },
    "Failed to update setting": {
      hash: "2272a1ceb0f4084b",
    },
    "For shifts that exceed {{shiftHours}} hours, required break is {{breakMinutes}} minutes": {
      hash: "2a9946d5fcbee4bc",
    },
    "Grace period updated successfully": {
      hash: "a3b28bc1ac2c4a56",
    },
    "Has active shifts in the next 2 weeks": {
      hash: "5ad1562de87b82a2",
    },
    Hidden: {
      hash: "7e6fefff0f0aeb6c",
    },
    "HostedTime device ID": {
      hash: "e891d5cd0ea25608",
    },
    "HostedTime device ID updated successfully": {
      hash: "467f1e45cb2e15d7",
    },
    "HostedTime integration device ID": {
      hash: "76eef37fa34912c2",
    },
    "If this is turned on, professionals can propose a new pay rate, giving your workplace a fast way to fill more shifts.":
      {
        hash: "2b9d1e8092595413",
      },
    "If this is turned on, professionals can propose a new pay rate, giving your workplace a fast way to fill more shifts. Learn more at the support center.":
      {
        hash: "e1fc7d1f6da04cae",
      },
    "Is this workplace integrated with Maple?": {
      hash: "990e61f759a1f123",
    },
    "Job Management": {
      hash: "04f96eeb9c8090d1",
    },
    Language: {
      hash: "a4fe65264ef7dbb3",
    },
    "Late-cancellation call instructions": {
      hash: "af40ec4cf6746601",
    },
    "Late-cancellation call notification": {
      hash: "2be38aafe50a4f66",
    },
    "Late-cancellation call notification disabled successfully.": {
      hash: "45c8b057b93a9fc8",
    },
    "Late-cancellation call notification updated successfully.": {
      hash: "a128ad6c18e63fc5",
    },
    "Learn more": {
      hash: "1445799c033a2d17",
    },
    "Leave empty to apply orientation at the workplace level: only a single orientation is required for a professional for any qualification. Select qualifications to require orientation only for those, with each completed orientation counting toward the qualification it covered.":
      {
        hash: "f01334330fe346ac",
      },
    "Location updated successfully": {
      hash: "962906f4f658a9a2",
    },
    "Manage booking modes and shift hour limits.": {
      hash: "2763e3a812c08d7a",
    },
    "Manage job settings for child facilities.": {
      hash: "f0dfe26e63bc8617",
    },
    "Manage jobs for my child facilities": {
      hash: "1dcfa9963127e7d0",
    },
    "Mandatory break disabled successfully.": {
      hash: "627ea0e020d09b9b",
    },
    "Mandatory break policy": {
      hash: "aee6b41152429015",
    },
    "Mandatory break policy updated successfully.": {
      hash: "7688d2f7598780ca",
    },
    "Mandatory break rules updated successfully.": {
      hash: "3618d4f084e7c98c",
    },
    "Maple integration updated successfully": {
      hash: "e5c54aa7e72bb752",
    },
    "Maximum consecutive hours": {
      hash: "900b85f3c4e41b75",
    },
    "Maximum weekly hours": {
      hash: "30dd117c4f6b1bf9",
    },
    "Move {{label}} down": {
      hash: "b1c733b78cb882ff",
    },
    "Move {{label}} up": {
      hash: "fe5d18d769b290af",
    },
    "No job management settings are available for this workplace.": {
      hash: "d2752a3342c348f8",
    },
    "No professional types configured for this workplace.": {
      hash: "160f3779e2189100",
    },
    "No rate and billing settings are available for this workplace.": {
      hash: "3eabdb54abdd1e4d",
    },
    None: {
      hash: "dc937b59892604f5",
    },
    "Number of hours before a shift starts to consider it 'starting soon' and highlight professionals who still need credentials.":
      {
        hash: "6ef0516afc1179be",
      },
    "Onboarding View": {
      hash: "e0350a790c9138d1",
    },
    "Only administrators can change these settings. Contact Clipboard support to request changes.":
      {
        hash: "ec37e0df8aea84f1",
      },
    "Orientation length": {
      hash: "d92c232bd70bea33",
    },
    "Orientation length must be a whole number between {{minimum}} and {{maximum}} minutes": {
      hash: "2f299751a552286f",
    },
    "Paid rest period policy": {
      hash: "17ce210985676544",
    },
    Platform: {
      hash: "c78ffe19571018fb",
    },
    Policy: {
      hash: "c611981fab983bc6",
    },
    "Prevent professionals from booking double shifts": {
      hash: "0e520b951ba12cc3",
    },
    "Prevent professionals from booking excessive weekly hours": {
      hash: "65602a19e4ee5fd9",
    },
    "Prevent professionals from clocking in early": {
      hash: "cfa3e1caf0b1b2d8",
    },
    "Provide optional paid rest periods": {
      hash: "6ce93b6727c1ec8a",
    },
    "QR code sign out updated successfully": {
      hash: "709ce46141701cfb",
    },
    "Qualification-specific orientation": {
      hash: "e9d01a96cb9107e8",
    },
    "Rate & Billing": {
      hash: "21b66fba384beedc",
    },
    "Rate negotiation setting updated successfully": {
      hash: "cf7da5d7167f32c7",
    },
    Reason: {
      hash: "f81ab834de5f8491",
    },
    "Remove break rule": {
      hash: "dfb40b548c292714",
    },
    "Request to Book settings updated successfully": {
      hash: "026b7a3a2f6d7697",
    },
    "Require a badge during shifts": {
      hash: "4496feb166897bf2",
    },
    "Require mandatory break": {
      hash: "712ee289a8a1a83a",
    },
    "Rest break policy updated successfully.": {
      hash: "9a1ac0f4474c012b",
    },
    "Rest breaks disabled successfully.": {
      hash: "8e3323ee7d5c7ed9",
    },
    "Restrict shift invites that would exceed 17 hours per day": {
      hash: "2b31bc9806c47521",
    },
    "Restrictions must be no less than {{minimumHours}} hours": {
      hash: "cb02f5f5f85042d2",
    },
    "Review and edit late-cancellation call instructions": {
      hash: "a6a219dce5737ccf",
    },
    "Review and edit the paid rest period policy": {
      hash: "c5fd090e8930f78e",
    },
    "Review and edit your facility's mandatory break policy": {
      hash: "3ff700627da62ace",
    },
    Save: {
      hash: "1509f561f2416598",
    },
    "Save Changes": {
      hash: "35322b5bb5a218a1",
    },
    "Schedule preferences updated successfully": {
      hash: "d745023be91784c2",
    },
    Scheduling: {
      hash: "ed5c58303a981baa",
    },
    Select: {
      hash: "2a78025de6aae5e7",
    },
    "Select facilities": {
      hash: "516815728ebada54",
    },
    "Select the facilities that you want to manage jobs for.": {
      hash: "bafba7a74c5477f4",
    },
    Server: {
      hash: "aef7de28d52977f1",
    },
    "Set badge requirements, sign-out methods, and charting compliance.": {
      hash: "15b937dfd1192007",
    },
    "Set the maximum number of consecutive work hours allowed within a 24-hour period.": {
      hash: "37c36d3083a02a9d",
    },
    "Set the maximum number of work hours allowed per week (Sunday to Saturday).": {
      hash: "c587ea41a339ba29",
    },
    "Setting updated successfully": {
      hash: "32eb2aafbde6005b",
    },
    Settings: {
      hash: "74a883a037bc227f",
    },
    "Shift Starting Soon Threshold": {
      hash: "0c5c6608de487c25",
    },
    "Shift length in hours": {
      hash: "d020f667999d89b9",
    },
    "Shifts will be automatically verified for clocking out up to {{minutes}} {{unit}} over their scheduled shift end time. Only applied when shift extension is enabled for this workplace.":
      {
        hash: "f714dda64c6790b5",
      },
    "Show or hide professional types on the calendar. Use arrows to reorder.": {
      hash: "f91bbb0188572f4b",
    },
    Spanish: {
      hash: "3411059cb8e0660e",
    },
    "Start of Shift Orientation": {
      hash: "cddc9d387f818111",
    },
    "Start of Shift Orientation configuration": {
      hash: "db7ee8ce4a71ce8b",
    },
    "Start of Shift Orientation disabled successfully.": {
      hash: "47c3da40b86b4093",
    },
    "Start of Shift Orientation updated successfully.": {
      hash: "81b7aedb5393dc88",
    },
    "Tag deleted successfully": {
      hash: "cb0e058f95cae151",
    },
    "Tags requested successfully": {
      hash: "a29b245ffea6c861",
    },
    "The duration in hours a professional has to return and complete charting.": {
      hash: "a912692269072e1d",
    },
    "This workplace requires that all Independent Contractors using Clipboard wear a badge at all times during a shift.":
      {
        hash: "936e661e1282b74a",
      },
    "Time & Attendance": {
      hash: "a6677f62a5e6437c",
    },
    Timekeeping: {
      hash: "5306e22284383c9e",
    },
    "To modify the workplace's Request to Book setting, submit a request in #proj-request-to-book":
      {
        hash: "cf3b00d3f19d1a1f",
      },
    "Toggle on to automatically verify shifts that clock out shortly after their scheduled end time. Only applied when shift extension is enabled for this workplace.":
      {
        hash: "a9c5f50f24ffd660",
      },
    "Update ID": {
      hash: "42dac2c38c3d6b20",
    },
    "Updated settings": {
      hash: "ef593bf59fb4f1a1",
    },
    Version: {
      hash: "dd167905de0defca",
    },
    "Visible on calendar": {
      hash: "e7f458685df1a5c3",
    },
    "We will not charge you for clocked time before a shift's posted start time. Only applies to shifts worked after making this change. Please note that this may affect punctuality.":
      {
        hash: "c8cfe723d85dcdd3",
      },
    "Weekly hours limit must be no less than {{minimumHours}} hours": {
      hash: "0b0ee7aea59f7a20",
    },
    "Weekly hours limit must be no more than {{maximumHours}} hours": {
      hash: "aed4b0940be3c757",
    },
    "When enabled, Clipboard will call the specified number per the instructions below if a professional cancels within 8 hours of the shift start time or no-shows.":
      {
        hash: "8ed3f28051797677",
      },
    "When enabled, a professional's first shift at this workplace starts earlier to include time for orientation.":
      {
        hash: "05d8e4ffb7e2376a",
      },
    "When enabled, expiring break payment requests will be declined. When disabled, they will be approved.":
      {
        hash: "f4022f08f2be1d48",
      },
    "When enabled, professionals can be recalled to complete charting. Professionals with incomplete charting will also be blocked from booking at your workplace.":
      {
        hash: "63019196ab3f47bc",
      },
    "When enabled, shows professionals who are missing credentials and have upcoming shifts, so credentials can be shared before their shift starts.":
      {
        hash: "fa432f02d32b7530",
      },
    "When enabled, staff at your workplace can scan a QR code to provide signatures and anonymous feedback at the end of shifts.":
      {
        hash: "fbb406ff9171f080",
      },
    "When enabled, the rest period policy will be visible to professionals in the app.": {
      hash: "cc3412a260c1fee8",
    },
    "When enabled, workplace users cannot send invites that would cause a professional to work more than 17 hours within a 24-hour period.":
      {
        hash: "b3aab3f479896b30",
      },
    "When enabled, workplace users will be able to share and manage charting credentials on behalf of workers.":
      {
        hash: "0ece9ff6f24f85f5",
      },
    "When enabled, workplace users will be able to share and manage timekeeping credentials on behalf of workers.":
      {
        hash: "cabfc417fcda90b4",
      },
    "Worker Credentials": {
      hash: "a4382a439a776868",
    },
    "Worker credential configuration updated successfully": {
      hash: "3418da3652d49b70",
    },
    "You have unsaved break policy changes. Are you sure you want to leave?": {
      hash: "20a3669ea603e118",
    },
    hours: {
      hash: "404314b1f4bd8fa2",
    },
    min: {
      hash: "1f6fa6f69d185e60",
    },
    minute: {
      hash: "28cdd20eaf134a05",
    },
    minutes: {
      hash: "90e63d85fa1ab2c8",
    },
    "update settings": {
      hash: "da9d85b8c6acc03a",
    },
  },
  shift: {
    ". Note, you won't be charged any additional fees, just the standard shift rate.": {
      hash: "378f90f28922eec0",
    },
    Approve: {
      hash: "6007acbe30b2cd98",
    },
    "Approve Missed Punch Request": {
      hash: "f246a247c38be344",
    },
    "Approved break": {
      hash: "8866ebaf72d9db46",
    },
    "Approved clock in": {
      hash: "9df3293f4edcce3a",
    },
    "Approved clock out": {
      hash: "525c9d4fc3aaa4bc",
    },
    "Arrived at workplace": {
      hash: "829ba374dbf79ec2",
    },
    "At or after": {
      hash: "f412428aae20acc4",
    },
    "At or before": {
      hash: "7e18daf2589c64cf",
    },
    "Auto-approves in": {
      hash: "e7031d9ebf8f138f",
    },
    Back: {
      hash: "76900f1bfd16c8d4",
    },
    "Before you mark No Show, we wanted to flag that the worker seems to be moving towards your workplace.":
      {
        hash: "23f8b3f3130644fa",
      },
    "Before you mark No Show, we wanted to flag that the worker seems to be within a mile of your workplace.":
      {
        hash: "7c4812fdf490b279",
      },
    Break: {
      hash: "f71081fb0af48ae6",
    },
    "Break Payment Request": {
      hash: "b6e84006a2d887fb",
    },
    "Break request": {
      hash: "d61f429ffad6746a",
    },
    "Break start": {
      hash: "427d09f7274f2b9c",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Charge Breakdown": {
      hash: "215020d85a22dd6d",
    },
    Clear: {
      hash: "83b12c2216efb4fd",
    },
    "Clock compliance video": {
      hash: "d8c4a2cd2bfcee03",
    },
    "Clock in": {
      hash: "09adde92f00886ef",
    },
    "Clock in time": {
      hash: "8f227bc8dd1f19c3",
    },
    "Clock in video": {
      hash: "896ed1586c784540",
    },
    "Clock out": {
      hash: "45733af728fba90d",
    },
    "Clock out time": {
      hash: "e005cecbc48072c2",
    },
    "Clock out video": {
      hash: "eaac9a61b76662c5",
    },
    Close: {
      hash: "7d9eb7acb13e2462",
    },
    "Collapse expiry details": {
      hash: "8e409e7990b1dec4",
    },
    "Compliance Videos": {
      hash: "79b37076beca8703",
    },
    "Confirm times": {
      hash: "c12f42ab6906563c",
    },
    "Correct & approve": {
      hash: "31a43e88b660bc5f",
    },
    Decline: {
      hash: "a2d285b352873457",
    },
    "Decline Break Payment Request": {
      hash: "0c68f8811f1b4745",
    },
    "Decline Missed Punch Request?": {
      hash: "8d1e257246c30f33",
    },
    "Did the worker leave with your permission?": {
      hash: "989c2818e8546505",
    },
    "Disagree with the time? Approve a corrected one.": {
      hash: "a66279e9d80fdce2",
    },
    Dispute: {
      hash: "3a8931a9b2f6bf69",
    },
    "Distance:": {
      hash: "5635fd1470060191",
    },
    Duration: {
      hash: "4fc52a3c4c558b51",
    },
    "ETA:": {
      hash: "e5752d7cd0661ffa",
    },
    "Edit break time": {
      hash: "028ff6788c05afa8",
    },
    "Edit clock in time": {
      hash: "ff967bedfdeba1aa",
    },
    "Edit clock out time": {
      hash: "0bfb51f390b55eb6",
    },
    "Error downloading timesheets": {
      hash: "1610dcd8f5e4eb1d",
    },
    "Error loading signature": {
      hash: "3fba5ca0ea213e15",
    },
    "Error loading video.": {
      hash: "805dcf0e47b9268a",
    },
    "Error printing timesheets": {
      hash: "ef80bb8ce97b8d1d",
    },
    "Expand expiry details": {
      hash: "dac73427e17591e5",
    },
    "Expires in": {
      hash: "de9967524f056889",
    },
    "Failed to approve missed punch request": {
      hash: "6c549ee1e989f842",
    },
    "Failed to decline missed punch request": {
      hash: "29b9c49ceced7a4f",
    },
    "Failed to upload signature": {
      hash: "bd15ec9cca8c0f3a",
    },
    "I confirm this professional was a No Show.": {
      hash: "abc9cac5db1dbf64",
    },
    "Last Updated: {{lastUpdatedText}}": {
      hash: "5d70db404f538fe6",
    },
    "Left workplace": {
      hash: "05641494de57fcc2",
    },
    "Live tracking": {
      hash: "61374592cd46e0e5",
    },
    "Missed Punch Request": {
      hash: "b74a51297835aaf2",
    },
    "Missed Punch Request approved": {
      hash: "2eb26f243ef314c9",
    },
    "Missed Punch Request denied": {
      hash: "39c825bb1fb21d75",
    },
    "Missed clock in": {
      hash: "8794e1c96bc12483",
    },
    "Missed clock out": {
      hash: "9b03a3e87f69497d",
    },
    "More options": {
      hash: "bc79cdffbaa8df09",
    },
    "N/A": {
      hash: "e2f79e5b60330bba",
    },
    "New hours": {
      hash: "c731384aad60d2cc",
    },
    "New total": {
      hash: "02a63a5edd1acb79",
    },
    "No, I don't need a replacement worker for this shift.": {
      hash: "cd7a2f68b7d6acf7",
    },
    "No, this worker left without permission.": {
      hash: "a5da3ca559b94b1c",
    },
    "Not recorded": {
      hash: "b37c7879f6c359f6",
    },
    "Nursing services assignment": {
      hash: "219a8125870cbae2",
    },
    "Overridden by {{overriddenByName}}": {
      hash: "d5dc4dc63d4be8b5",
    },
    "Paid hours": {
      hash: "ccde26902b9baa9d",
    },
    "Please add notes to describe the No Show event in more detail.": {
      hash: "2682d64f56d4520e",
    },
    "Please confirm that this professional was a No Show.": {
      hash: "0427ec78ba6e5aa9",
    },
    "Please describe the situation": {
      hash: "e6bfe21185e3f9a3",
    },
    "Please explain why you are approving this missed punch request on behalf of the workplace.": {
      hash: "f5c12a23ee6fa88d",
    },
    "Provide any relevant details or evidence for approving this request.": {
      hash: "4e58cd5500f23d06",
    },
    "Provide any relevant details or evidence.": {
      hash: "901ded342e740048",
    },
    'Provide any relevant details or evidence. E.g., "when checking our security camera recordings as well as our records, it&apos;s clear you took at least a full break."':
      {
        hash: "336aa39ab810e1ba",
      },
    Rate: {
      hash: "45b63ffd01af7b9c",
    },
    Reason: {
      hash: "f81ab834de5f8491",
    },
    "Reject and keep original time": {
      hash: "4ba2e28476a135a9",
    },
    "Reject full shift": {
      hash: "bcbee36c4b46574b",
    },
    "Requested break": {
      hash: "a56346531cb85449",
    },
    "Requested clock in": {
      hash: "88d13fb561f5f0ae",
    },
    "Requested clock out": {
      hash: "b141deb247a324d0",
    },
    "Requested hours": {
      hash: "c945ef2b1e798905",
    },
    "Requested total": {
      hash: "61b026bea0a35469",
    },
    "Review request": {
      hash: "dcea8abbdff03524",
    },
    "Sign & Approve": {
      hash: "753ed53df5d6e46a",
    },
    Signature: {
      hash: "f1a73e2204a11407",
    },
    Signed: {
      hash: "08251562b3407a16",
    },
    "Since it is uncommon for this professional to submit Missed Punch Requests, this request will auto-approve on {{formattedExpiryDate}}.":
      {
        hash: "3a3a98ffcc9fbd48",
      },
    "Since this professional recently submitted a Missed Punch Request, this request will expire on {{formattedExpiryDate}}.":
      {
        hash: "021e9a362a4994f4",
      },
    Skipped: {
      hash: "12698ce1ea5cd4ab",
    },
    "Skipped break": {
      hash: "02a373602df5e9c7",
    },
    "Station/Wing/Unit/Floor": {
      hash: "feb7906e6f52183e",
    },
    "The shift data could not be loaded. Please, try again later.": {
      hash: "b25ab4ef060a24e6",
    },
    "There was an error while loading the break request data. Please try again.": {
      hash: "5f4ca2b9dc0be27a",
    },
    "These are the times that will be approved for this shift.": {
      hash: "474e899ce7de15bb",
    },
    "This information will be recorded for audit purposes and may be displayed to the workplace and worker":
      {
        hash: "e060705826724633",
      },
    "This information will be shared with the professional": {
      hash: "f8761a6adc77d9d0",
    },
    "This is the break that will be approved for this shift.": {
      hash: "3eafb1d3e170874c",
    },
    "This is the time that will be approved for this shift.": {
      hash: "9767bb53ab3b0419",
    },
    Timeline: {
      hash: "9dcff98e275f0cb9",
    },
    Total: {
      hash: "c9b3c38247f744e1",
    },
    "Unable to load charge rate details": {
      hash: "a17a99d060752978",
    },
    "Verified Shift": {
      hash: "77bbaafb4cd49df5",
    },
    "View billable hours": {
      hash: "d8b80fa1b071170a",
    },
    "View dispute": {
      hash: "79c2657890c42470",
    },
    "View rate breakdown": {
      hash: "51f015a9ef778940",
    },
    "View request": {
      hash: "9c9c3275d4f0b964",
    },
    "We are already looking for a replacement worker for this shift. If you still want to cancel the shift, you'll be able to after this step.":
      {
        hash: "c5b309b1e9c2d334",
      },
    "We seem to have lost connection.": {
      hash: "ef0ed3ac55b074c5",
    },
    "Why is the worker leaving the shift early?": {
      hash: "bfbcdf460d925a2a",
    },
    "Worker Profile": {
      hash: "582d5b22c05c968b",
    },
    "Would you like Clipboard to look for a replacement for this shift?": {
      hash: "4dc118081ffe8038",
    },
    "Yes, I'd like Clipboard to post an": {
      hash: "0e45302a9b0a1380",
    },
    "Yes, and I am okay with this worker leaving early.": {
      hash: "861420e5f6afa58d",
    },
    "You do not have permission to review the request": {
      hash: "84a350e29c34791c",
    },
    "You do not have permissions to approve/decline Extra Worked Time Requests": {
      hash: "892359d2dbcea6df",
    },
    "Your Professional": {
      hash: "d520eeb5335e09be",
    },
    "e.g. 2nd floor": {
      hash: "974fc8fbbcda6c55",
    },
    "e.g. Acute care": {
      hash: "183f9af034b83430",
    },
    hrs: {
      hash: "4e9682fa850ed767",
    },
    mins: {
      hash: "0c843ea50d04fd8d",
    },
    "urgent shift": {
      hash: "cba219dacebb145c",
    },
    "{{distanceInMiles}} mi": {
      hash: "9527010f2660676a",
    },
    "{{etaMinutes}} mins": {
      hash: "c19521a120ed2547",
    },
    "{{startTime}} – {{endTime}} ({{durationMinutes}} minutes)": {
      hash: "f005825b1b5a7719",
    },
  },
  shiftMigration: {
    ", starting": {
      hash: "4bd00ad4ed1bf62d",
    },
    "Address unavailable": {
      hash: "efb1b9fb7d251ac7",
    },
    "All shifts within the window are eligible to be migrated.": {
      hash: "9facfbe860f996cb",
    },
    Back: {
      hash: "76900f1bfd16c8d4",
    },
    "Back to parameters": {
      hash: "62f9a7361a1252e3",
    },
    Booked: {
      hash: "fd1331d7a6cd0309",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    Close: {
      hash: "7d9eb7acb13e2462",
    },
    "Confirm migration": {
      hash: "1af379f2d2ceaa59",
    },
    "Destination workplace": {
      hash: "95c31eb9f2200e41",
    },
    "Effective ending (optional)": {
      hash: "3a60e59aa097fe17",
    },
    "Effective starting": {
      hash: "910e12c594caf689",
    },
    "ID: {{id}}": {
      hash: "e87ced5e089eba2b",
    },
    "Migrate shifts": {
      hash: "234c7002b7c8b66f",
    },
    "Migrating shifts from": {
      hash: "87c06b34aacdedef",
    },
    "Migration complete": {
      hash: "a903eee3da327410",
    },
    "Migration completed successfully.": {
      hash: "57a0b86121d762e9",
    },
    "Migration failed": {
      hash: "511ed0936645a3a8",
    },
    Open: {
      hash: "ed077f3d8125d60d",
    },
    "Origin and destination addresses don't match. The backend will reject the migration unless the addresses are compatible.":
      {
        hash: "0cbbed3d4fb3b62d",
      },
    "Origin workplace": {
      hash: "4a49935a4ea295b9",
    },
    "Past, unfilled": {
      hash: "084589b75f7b2594",
    },
    "Pending verification": {
      hash: "417a6b7e1904940a",
    },
    "Preview migration": {
      hash: "47c2df10559485d2",
    },
    "Searching workplaces...": {
      hash: "cc2111dd92b635db",
    },
    "Shifts migrated": {
      hash: "59b75a09ad8728b6",
    },
    "Shifts that will be ignored": {
      hash: "ffc3898a1161a769",
    },
    "Shifts to migrate": {
      hash: "f7476d9ec6213488",
    },
    "Start typing workplace name...": {
      hash: "6031ee797185af1e",
    },
    "Starts soon": {
      hash: "44379762f7964194",
    },
    "The migration was not applied. Try again and run a new preview.": {
      hash: "34a078687bb02ed2",
    },
    Total: {
      hash: "c9b3c38247f744e1",
    },
    "Total ignored": {
      hash: "57393f549b1117cb",
    },
    "Total migratable": {
      hash: "46701bfc2e78c6e7",
    },
    "Unverified shifts cannot be migrated unless they start more than 4 hours in the future.": {
      hash: "e52e45d02310f868",
    },
    Verified: {
      hash: "4f7838402f37674e",
    },
    "name,userId,fullAddress": {
      hash: "9d8979e11fdead7a",
    },
    through: {
      hash: "9c6725dc269a48ce",
    },
    to: {
      hash: "663ea1bfffe5038f",
    },
  },
  shiftNotes: {
    "Edit shift note": {
      hash: "b7c0d007120b9767",
    },
    "Shift note": {
      hash: "e7ca563e7ef6c518",
    },
    "Show less": {
      hash: "94ea9b1d33a02975",
    },
    "Show more": {
      hash: "f5c9bd131486e793",
    },
    "This will be shown to professionals before they book this shift.": {
      hash: "a58558effdc5d28c",
    },
  },
  smsPortal: {
    Close: {
      hash: "7d9eb7acb13e2462",
    },
    "Copy email": {
      hash: "1449d5fb47172cac",
    },
    "Copy workplace ID": {
      hash: "8f8c8c8142bc3bce",
    },
    Email: {
      hash: "969ccbd3cf6300ec",
    },
    "Facility User": {
      hash: "063d16427da8d88a",
    },
    "Failed to load conversations": {
      hash: "ae55fc046c4cf3ae",
    },
    "Failed to load messages": {
      hash: "eeaaa7b4d5d7f090",
    },
    "Failed to load profile": {
      hash: "92907d8c70891118",
    },
    "Failed to send message. Please try again.": {
      hash: "25b345c161d37ee1",
    },
    "Failed to send mock SMS: {{message}}": {
      hash: "41a39ca90a9915d7",
    },
    "From: {{phone}}": {
      hash: "12bd656f89dac984",
    },
    Interviews: {
      hash: "0b9e49cf035bd75b",
    },
    "Load more": {
      hash: "ac8991ef01019cf5",
    },
    "Load older messages": {
      hash: "f17671d83db0da48",
    },
    "Loading...": {
      hash: "47d2a515ef2f05b8",
    },
    "Message body": {
      hash: "7136799df2d343e1",
    },
    "Mock SMS sent - check #knock-sms-replies-dev": {
      hash: "604bf413faba50fa",
    },
    "Mock inbound SMS reply": {
      hash: "50b5ff647ec2fb07",
    },
    Name: {
      hash: "dcd1d5223f73b3a9",
    },
    "No facility users found": {
      hash: "1e380e06fb20ef9f",
    },
    "No messages yet. Send the first message below.": {
      hash: "c21e016f5b62c9fb",
    },
    "No more messages": {
      hash: "8cb80a46a50f59e4",
    },
    Ops: {
      hash: "ca70b50942518156",
    },
    "Past interviews": {
      hash: "347130fa83e4cbe9",
    },
    "Receive message mock": {
      hash: "203a908d5a59c019",
    },
    Retry: {
      hash: "942087cc2d41e013",
    },
    "SMS Portal": {
      hash: "c7677b97318f448a",
    },
    "Search by phone, name, or workplace...": {
      hash: "198070bbff07ba8e",
    },
    "Search for a facility user by name, phone, or workplace": {
      hash: "53b41938bd3d3231",
    },
    "Select a conversation to view messages": {
      hash: "18c938b5aab50b5e",
    },
    Send: {
      hash: "f6f4688ff23d50c6",
    },
    "Send message": {
      hash: "93a26b1eaff99b3a",
    },
    "Sending...": {
      hash: "286a3af7348e8312",
    },
    Title: {
      hash: "7e8cd2056da73a7f",
    },
    "Triggers the SMS-reply Slack threading flow exactly as a real inbound SMS would. Posts to #knock-sms-replies-dev. Multiple sends thread together within the LD-controlled window.":
      {
        hash: "f0743d83f900e797",
      },
    "Type your message...": {
      hash: "e9bddf7360b6dc62",
    },
    "Unknown error": {
      hash: "27c2ccd962c2b8dc",
    },
    "Upcoming interviews": {
      hash: "f4486f0e1296fbd9",
    },
    "View Profile": {
      hash: "41a634bed37381ba",
    },
    Workplace: {
      hash: "09fd2948a8dffd21",
    },
    "Workplace User": {
      hash: "8d849d37ac0b8b55",
    },
  },
  spendingControls: {
    "Additional hours": {
      hash: "36070f2eaf96bd11",
    },
    "Additional hours needed": {
      hash: "8976f7983aefb33d",
    },
    "Apply to all upcoming weeks": {
      hash: "920c2e9272d7c60d",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    Confirm: {
      hash: "eebdd24a77d9ad32",
    },
    "Creating this shift exceeds the weekly spend limit set for your workplace. How many additional hours are needed for the week?":
      {
        hash: "f7d718d88896690a",
      },
    "Edit Spend Limit": {
      hash: "1ce8564993cc9ca4",
    },
    "Enable weekly limit": {
      hash: "38593914ba8b6bb5",
    },
    "Enter dollar amount": {
      hash: "f226b929723805ed",
    },
    "Enter hour amount": {
      hash: "0420c8cfb9f4056f",
    },
    "Enter value...": {
      hash: "813ede96a15c4c82",
    },
    "Estimated Total Hours": {
      hash: "377ad93554b126f9",
    },
    "Estimated Total Spend": {
      hash: "0efff1043328c356",
    },
    "How many additional hours are needed for this week beyond the shifts already posted?": {
      hash: "2d99e344a37673d9",
    },
    "Loading...": {
      hash: "47d2a515ef2f05b8",
    },
    "Next month": {
      hash: "74e53211fef4b4d4",
    },
    "Next week": {
      hash: "21fbde19cfb095cd",
    },
    "Previous month": {
      hash: "6a2769502a5dda78",
    },
    "Previous week": {
      hash: "c0f8bbcd417656cf",
    },
    "Request Increase": {
      hash: "efe7287d10ef5fe2",
    },
    "Request approval": {
      hash: "e013d99a98ac54d0",
    },
    "Saving...": {
      hash: "dc85af8f2b1d0d67",
    },
    "Set Spend Limit": {
      hash: "3845725f02579dbd",
    },
    "Spend Controls": {
      hash: "9a03073fb5cf415d",
    },
    "Spend increase request submitted.": {
      hash: "ad96512f119ff9c4",
    },
    "Spend limit reached for the week of the shift": {
      hash: "fc5236e6362fb5f6",
    },
    "Total Remaining Hours": {
      hash: "e0ab581aca1cd51a",
    },
    "Total Remaining Spend": {
      hash: "0ebb39cc4c16c273",
    },
    "Track your weekly spend": {
      hash: "562361f9ac5ecfd1",
    },
    "View and manage spend for your workplaces": {
      hash: "e33a24e7fd82e2cf",
    },
    "Weekly limit": {
      hash: "93483c938871b25a",
    },
    "fields[workplace]=name": {
      hash: "8c8900658a4c983f",
    },
    hrs: {
      hash: "4e9682fa850ed767",
    },
  },
  upcomingCharges: {
    "Additional charges for late cancellations, sent-home shifts, and other non-shift fees.": {
      hash: "c972b45d5870fe90",
    },
    Break: {
      hash: "f71081fb0af48ae6",
    },
    "Cannot verify shifts that haven't started yet": {
      hash: "833f7959e353683d",
    },
    "Charge Breakdown": {
      hash: "215020d85a22dd6d",
    },
    "Close panel": {
      hash: "a600b900f83db6cb",
    },
    Date: {
      hash: "99c40ab405926cb5",
    },
    Description: {
      hash: "526e0087cc3f254d",
    },
    Details: {
      hash: "45989de49fb7f66d",
    },
    Dispute: {
      hash: "3a8931a9b2f6bf69",
    },
    Disputed: {
      hash: "b3b310ca1276b3bb",
    },
    "Expiration N/A": {
      hash: "ebe4ecdf967339f2",
    },
    "Expires at {{formattedExpiration}}": {
      hash: "bdd239ff57e1d330",
    },
    "Failed to load pending requests. Please try again later.": {
      hash: "b5396293134e602c",
    },
    "Failed to load upcoming charges. Please try again later.": {
      hash: "8cd819f501f556ca",
    },
    "Fee Details": {
      hash: "1c525cb12fd03c7c",
    },
    "Fee Type": {
      hash: "9a57000511753181",
    },
    Fees: {
      hash: "6d80486cc33a915c",
    },
    License: {
      hash: "c011d6097bfbc8e9",
    },
    "No fees": {
      hash: "96173be4ed57f043",
    },
    "No pending requests": {
      hash: "883a9f47c79e8901",
    },
    "No verified shifts": {
      hash: "872d718dc4dcdfb8",
    },
    "Off-cycle": {
      hash: "88494a53861aa061",
    },
    "Paid Hours": {
      hash: "d8edefa82a64defb",
    },
    "Paid hours": {
      hash: "ccde26902b9baa9d",
    },
    "Pending Requests": {
      hash: "87b17944085875ed",
    },
    "Pending break payment request": {
      hash: "2035fb74b10109c5",
    },
    Professional: {
      hash: "19c73a5cdf346d96",
    },
    Rate: {
      hash: "45b63ffd01af7b9c",
    },
    "Rate (/hr)": {
      hash: "f57c4300d5f50247",
    },
    Retry: {
      hash: "942087cc2d41e013",
    },
    Review: {
      hash: "aff0766a5290e117",
    },
    "Shift Times": {
      hash: "62d6ee886349c247",
    },
    "Shift Type": {
      hash: "ad30ad3bffc8184d",
    },
    Shifts: {
      hash: "3c653dabeef2e3c2",
    },
    Status: {
      hash: "920e413c7d411b61",
    },
    "Time requested": {
      hash: "0ddf43e264f68a12",
    },
    Total: {
      hash: "c9b3c38247f744e1",
    },
    Unverified: {
      hash: "33c8e8de41c3a351",
    },
    "Upcoming Charges": {
      hash: "a2fb237d15320535",
    },
    Verified: {
      hash: "4f7838402f37674e",
    },
    "Verified Shifts": {
      hash: "0f295eecfb3433d7",
    },
    "Verify Shift?": {
      hash: "3ec6e3941da4c010",
    },
    "View details": {
      hash: "d1bf045bb524dae5",
    },
    "View dispute": {
      hash: "79c2657890c42470",
    },
  },
  workerDocuments: {
    "An error occurred while preparing the document for download. Please try again.": {
      hash: "e660e4b07c7b75c9",
    },
    "An error occurred while preparing the document for printing. Please try again.": {
      hash: "1eaa68d4c375ffa4",
    },
    "Back to documents list": {
      hash: "cacfb7d8705ac666",
    },
    "Clear selection": {
      hash: "cea4d2e010b8fd52",
    },
    "Close documents": {
      hash: "43bef92ae98c1c0e",
    },
    "Close viewer": {
      hash: "7b25a882e9bc3515",
    },
    "Dismiss error": {
      hash: "2db046678b9c9d1d",
    },
    "Document preview": {
      hash: "7009e4afe3c497d5",
    },
    Documents: {
      hash: "b4e929d8bcfe0418",
    },
    Download: {
      hash: "d6eafe8235910042",
    },
    "Failed to load documents. Please try again.": {
      hash: "5265434bb9e0e789",
    },
    Missing: {
      hash: "6be36ca49ee85210",
    },
    Next: {
      hash: "1ff57a29d7c9d11b",
    },
    "Next document": {
      hash: "34fd124089a65f58",
    },
    "No optional documents": {
      hash: "5e4fd81d3a118c16",
    },
    "No required documents": {
      hash: "44837fdf5b780b73",
    },
    Optional: {
      hash: "59be71333c960fd0",
    },
    Previous: {
      hash: "a57b08a480b822a0",
    },
    "Previous document": {
      hash: "a64c8281778a453a",
    },
    Print: {
      hash: "df0fe79898ef413e",
    },
    Required: {
      hash: "4850b174b713d88c",
    },
    Retry: {
      hash: "942087cc2d41e013",
    },
    "Rotate clockwise": {
      hash: "fb594c58c73d2bf8",
    },
    "Rotate counter-clockwise": {
      hash: "ea2b3062479788f4",
    },
    "Select all": {
      hash: "1fc9a387654d410f",
    },
    "There is already a download in progress. Please wait for it to complete.": {
      hash: "cbeec9440db96406",
    },
    "Zoom in": {
      hash: "0e47f09a748fa132",
    },
    "Zoom out": {
      hash: "bc7b631a689b45ca",
    },
    "{{selectedCount}} selected": {
      hash: "6812a1612e7756b4",
    },
  },
  workerProfile: {
    About: {
      hash: "4efca0d10c5feb8e",
    },
    "Assigned to another worker": {
      hash: "adb9935aefa97d3e",
    },
    "Booked Shifts": {
      hash: "f3314dc78a3e0b64",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    Chat: {
      hash: "460b3a7da007b7af",
    },
    "Close dialog": {
      hash: "c8df66c5fe3f97d0",
    },
    "Close worker profile": {
      hash: "67d6056ee9847bae",
    },
    "Conflicting email": {
      hash: "e5ca7c2158feb265",
    },
    "Conflicting phone number": {
      hash: "9334611a1a15bf72",
    },
    "Copy Worker ID": {
      hash: "58c687242ef4a408",
    },
    "Copy email": {
      hash: "1449d5fb47172cac",
    },
    "Copy phone number": {
      hash: "d5d6b83a02cc8d54",
    },
    Documents: {
      hash: "b4e929d8bcfe0418",
    },
    "Download badge": {
      hash: "7ded289ec39c7cd4",
    },
    Email: {
      hash: "969ccbd3cf6300ec",
    },
    "Email already assigned": {
      hash: "17251b2b0d826547",
    },
    "Error while creating badge": {
      hash: "2dee151577ec46d9",
    },
    "Failed to load documents.": {
      hash: "e6284f231417b888",
    },
    "Hide SSN": {
      hash: "59a733f98dcb56f5",
    },
    "Hide all shifts": {
      hash: "c8ae57613e6c105c",
    },
    Missing: {
      hash: "6be36ca49ee85210",
    },
    "No booked shifts yet.": {
      hash: "b522e0c2b9b83ef7",
    },
    "No documents to display": {
      hash: "f16c49174aa5a90e",
    },
    "No eligible role found for creating a badge.": {
      hash: "d7d98b9629d60ef6",
    },
    "No other shifts": {
      hash: "81421485e4fa5111",
    },
    "No skills listed yet": {
      hash: "26d5f8d94008a3b5",
    },
    "Open conflicting worker profile": {
      hash: "1c30873ebfe024a3",
    },
    "Open the conflicting worker profile and remove or update the email before trying again.": {
      hash: "2ebd3eee0ba59ac5",
    },
    "Open the conflicting worker profile and remove or update the phone number before trying again.":
      {
        hash: "a2e197a272fd5b1c",
      },
    Phone: {
      hash: "63dceb8800b2dd4a",
    },
    "Phone number already assigned": {
      hash: "72bbae008b725622",
    },
    Profile: {
      hash: "d696a35bdd1883da",
    },
    Qualifications: {
      hash: "7b4339cf860e01a6",
    },
    "Reveal SSN": {
      hash: "06183a1704302fd0",
    },
    "Select the role for the professional to create the badge": {
      hash: "c363496546214eb6",
    },
    "Share credentials": {
      hash: "257c8051763d5f71",
    },
    Skills: {
      hash: "66d0f523a379b2de",
    },
    "There was an error loading this worker's SSN. Please try again later.": {
      hash: "769f89083fef5866",
    },
    "This email is already used by another worker.": {
      hash: "0e3b8409d3390f10",
    },
    "This phone number is already used by another worker.": {
      hash: "c17c7df1213d835a",
    },
    Unblock: {
      hash: "712da63171e0c9de",
    },
    "View All Documents": {
      hash: "87cd0f2528b0314b",
    },
    "View all shifts": {
      hash: "82b062f1b5d11be7",
    },
    "Worker ID": {
      hash: "069d7e9d898e4d81",
    },
    "Worker documents": {
      hash: "7db0470e986eabd5",
    },
    "Worker profile could not be loaded.": {
      hash: "8794836f7f6f7de0",
    },
    "Worker skills": {
      hash: "34959850195f221e",
    },
    "name tmz": {
      hash: "937d7af2b0a4d271",
    },
  },
  workplaceChargeLeadTimeDifferentials: {
    "+ Add tier": {
      hash: "7d2f6a7754d58b7b",
    },
    "Add tier": {
      hash: "98167f67ad7f2ad1",
    },
    "Between {{minimumHours}} and {{maximumHours}} hours.": {
      hash: "29615b6c84d469a4",
    },
    "Between {{minimumPercent}}% and {{maximumPercent}}%.": {
      hash: "6ca7478fe7384fbe",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Charge differential on top of base charge": {
      hash: "3f5ac997aacafd3b",
    },
    Create: {
      hash: "4759498ac2a719c6",
    },
    Delete: {
      hash: "e2d0a54968ead24e",
    },
    "Failed to add tier": {
      hash: "45ef29b75657779f",
    },
    "Failed to delete tier": {
      hash: "030cd98636706bfc",
    },
    "Failed to load tiers. Try refreshing.": {
      hash: "63cc42e756e0dfad",
    },
    "Legacy rush fee applies until a Rush Fee Schedule tier is added": {
      hash: "1428ca351bbee731",
    },
    "No tiers configured. Add one to start applying lead-time charge differentials.": {
      hash: "1d286cfa8b050852",
    },
    "Shift Rush Fee Schedule": {
      hash: "8ba512b5611a0b76",
    },
    "Shifts created within the threshold hours of start time will have the listed charge differential added on top of the Workplace Base Charge.":
      {
        hash: "041a6694b3bb1286",
      },
    "Shifts created within the threshold of start time will have the charge differential added on top of the Workplace Base Charge.":
      {
        hash: "0e48ffeec1f32305",
      },
    "Threshold (hours)": {
      hash: "a9ffa37c57370176",
    },
    "Tier added": {
      hash: "8c00bdc065aac77d",
    },
    "Tier deleted": {
      hash: "da7d002ac58c3013",
    },
    "e.g. 12": {
      hash: "89c3016595a8ae9d",
    },
    "e.g. 5": {
      hash: "e6d53f2e5db0aed7",
    },
  },
  workplaceRulesQuiz: {
    "Answer Options": {
      hash: "536fbcf0eb525e3e",
    },
    "Answer:": {
      hash: "64f89cf423ee1a16",
    },
    Cancel: {
      hash: "19766ed6ccb2f4a3",
    },
    "Correct answer": {
      hash: "fb019d338b4305ef",
    },
    "Error generating quiz. Please, try again or contact support.": {
      hash: "9b6056e6e1d22e07",
    },
    "Flag an issue": {
      hash: "3a83868ee622f159",
    },
    "Generate Quiz": {
      hash: "5da69270e5973c17",
    },
    "Generating quiz": {
      hash: "eb04339b6ede32d6",
    },
    "Here's an example of a question from your workplace's quiz:": {
      hash: "e46a04e59f962c73",
    },
    "Keep Your Quiz Up to Date": {
      hash: "3b0a293c2fc1c76c",
    },
    "Learn More.": {
      hash: "b36f1afa14454c1c",
    },
    "May take up to a minute": {
      hash: "fd31b864096d4fc3",
    },
    "Most workplaces have this turned on.": {
      hash: "62035cce0bd17f2f",
    },
    "Please share details on the problem below and a member of our team will address the problem and get back to you within 1 business day. To turn quizzes off, adjust the toggle under “Quiz Requirement”.":
      {
        hash: "a39ae68e40a3a207",
      },
    "Professionals who are new to your workplace will take this quiz before their first shift if you toggle the quiz on. Review the quiz to ensure that it covers your workplace's rules. If there are any changes you'd like to make to the quiz, edit your rules below.":
      {
        hash: "cba9177d5d326157",
      },
    "Professionals who are new to your workplace will take this quiz before their first shift. Review the quiz to ensure that it covers your workplace's rules. If there are any changes you'd like to make to the quiz, edit your rules below.":
      {
        hash: "4bd1e71db44f8e19",
      },
    "Question {{questionIndex}}": {
      hash: "06cf0ff4df1ac1c6",
    },
    "Question:": {
      hash: "54de7f6007056e6f",
    },
    "Quiz could not be generated from the current rules. Adjust your notes and try again.": {
      hash: "82eaf2cc44a413e8",
    },
    "Quiz failed to generate. Please try again or contact support.": {
      hash: "aae3d09135e30194",
    },
    "Quiz is active": {
      hash: "d52baa251ff3a231",
    },
    "Quiz is not active": {
      hash: "e634b1a44f1f9a05",
    },
    "Quiz is ready. Review it to make sure it covers your rules.": {
      hash: "0997e8464b3e90bc",
    },
    "Review current quiz": {
      hash: "080ca4399b72fa20",
    },
    Save: {
      hash: "1509f561f2416598",
    },
    "Save updates": {
      hash: "9a39b66545015463",
    },
    "Share Rules and Expectations": {
      hash: "82991cd57053196f",
    },
    "Share your workplace’s rules below and then toggle the quiz on to require professionals who are new to your workplace to read and take a brief quiz on these rules.":
      {
        hash: "a26a1554115d743f",
      },
    Submit: {
      hash: "155f816c0407310c",
    },
    "Successfully updated rules.": {
      hash: "0eaa40f12dbd8f88",
    },
    "Successfully updated rules. Please wait as we generate your new quiz!": {
      hash: "3f4662b6e471359c",
    },
    "Thank you for flagging an issue with your quiz": {
      hash: "b8a8b25930316a9f",
    },
    "Update the details below with your workplace’s current rules or any information you want professionals to know. Those who are new to your workplace will read these before their first shift if you toggle the quiz on. ":
      {
        hash: "02ac94b779729e39",
      },
    "Update the details below with your workplace’s current rules or any information you want professionals to know. Those who are new to your workplace will read these before their first shift. ":
      {
        hash: "de8bfc6eb3a0e5e1",
      },
    "Workplace Quiz": {
      hash: "ec4235ff36167cb0",
    },
    "Workplace Rules Quiz": {
      hash: "e3c8c9b2fc87dc21",
    },
    "You have unsaved changes. Are you sure you want to leave?": {
      hash: "322380c1273e3abd",
    },
    "Your changes have been saved. {{wrongNotesLengthMessage}}": {
      hash: "9ee56e90fa3bd1f1",
    },
    "Your permission level does not allow you to edit the information on this page. If you want to edit this page you may ask your administrator to update your role in the platform.":
      {
        hash: "eadcb509d415d4c8",
      },
  },
  workplaceUsers: {
    Active: {
      hash: "92340695899bd2d8",
    },
    "Close dialog": {
      hash: "c8df66c5fe3f97d0",
    },
    Deactivated: {
      hash: "4840a57222fc401c",
    },
    Email: {
      hash: "969ccbd3cf6300ec",
    },
    "Notification Preferences": {
      hash: "1e3564bdba890599",
    },
    "SMS notifications are disabled because no mobile number is set. Add a mobile number in Personal Information to enable SMS notifications.":
      {
        hash: "5c81e533cbb65983",
      },
    "Team Members": {
      hash: "e2204b3eaff613de",
    },
    "Web Push": {
      hash: "4ba2056e9ba62960",
    },
  },
} as const satisfies TranslationKeyMap;

/* eslint-enable max-lines -- generated translation artifact */
